/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Code generated by @carbon/icon-build-helpers. DO NOT EDIT.
 */
import React from 'react';
import Icon from '../Icon.js';
import { i as iconPropTypes } from '../iconPropTypes-4cbeb95d.js';
import '@carbon/icon-helpers';
import 'prop-types';

var _circle, _path, _circle2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _circle3, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _circle4, _path41, _circle5, _path42, _circle6, _path43, _circle7, _path44, _circle8, _circle9, _path45, _circle10, _path46, _path47, _circle11, _path48, _circle12, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _circle13, _path57, _path58, _path59, _circle14, _circle15, _circle16, _circle17, _circle18, _path60, _path61, _path62, _circle19, _circle20, _circle21, _circle22, _path63, _path64, _path65, _circle23, _path66, _path67, _path68, _path69, _path70, _circle24, _circle25, _path71, _path72, _path73, _path74, _circle26, _path75, _path76, _path77, _path78, _path79, _path80, _circle27, _circle28, _path81, _path82, _path83, _path84, _path85, _circle29, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _circle30, _path96, _circle31, _path97, _circle32, _path98, _circle33, _path99, _circle34, _path100, _path101, _path102, _path103, _path104, _path105, _circle35, _path106, _circle36, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _circle37, _circle38, _path136, _path137, _circle39, _path138, _path139, _circle40, _circle41, _circle42, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _circle43, _path173, _path174, _circle44, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _switch, _circle45, _circle46, _circle47, _circle48, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _circle49, _circle50, _circle51, _path210, _path211, _circle52, _circle53, _path212, _circle54, _path213, _path214, _path215, _path216, _circle55, _path217, _circle56, _path218, _circle57, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _circle58, _circle59, _path237, _circle60, _circle61, _path238, _path239, _circle62, _circle63, _circle64, _path240, _path241, _circle65, _path242, _circle66, _path243, _circle67, _path244, _circle68, _path245, _path246, _circle69, _circle70, _circle71, _path247, _path248, _path249, _path250, _path251, _path252, _path253;
const didWarnAboutDeprecation = {};
const WatsonHealthHoleFilling = /*#__PURE__*/React.forwardRef(function WatsonHealthHoleFilling(_ref, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26,28H6a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,6,4H26a2.0023,2.0023,0,0,1,2,2V26A2.0023,2.0023,0,0,1,26,28ZM6,6V26H26.0012L26,6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthHoleFilling.propTypes = iconPropTypes;
}
const WatsonHealthHoleFillingCursor = /*#__PURE__*/React.forwardRef(function WatsonHealthHoleFillingCursor(_ref2, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref2;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: "19",
    cy: "19",
    r: "4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 30H10a2.0023 2.0023 0 01-2-2V10a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2V28A2.0023 2.0023 0 0128 30zM10 10V28H28V10zM11 2L2 2 2 11 4 11 4 4 11 4 11 2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthHoleFillingCursor.propTypes = iconPropTypes;
}
const Home = /*#__PURE__*/React.forwardRef(function Home(_ref3, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref3;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6123,2.2138a1.01,1.01,0,0,0-1.2427,0L1,13.4194l1.2427,1.5717L4,13.6209V26a2.0041,2.0041,0,0,0,2,2H26a2.0037,2.0037,0,0,0,2-2V13.63L29.7573,15,31,13.4282ZM18,26H14V18h4Zm2,0V18a2.0023,2.0023,0,0,0-2-2H14a2.002,2.002,0,0,0-2,2v8H6V12.0615l10-7.79,10,7.8005V26Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Home.propTypes = iconPropTypes;
}
const HorizontalView = /*#__PURE__*/React.forwardRef(function HorizontalView(_ref4, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref4;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28 30H4a2.0021 2.0021 0 01-2-2V20a2.0021 2.0021 0 012-2H28a2.0021 2.0021 0 012 2v8A2.0021 2.0021 0 0128 30zM4 20H3.9985L4 28H28V20zM28 14H4a2.0021 2.0021 0 01-2-2V4A2.0021 2.0021 0 014 2H28a2.0021 2.0021 0 012 2v8A2.0021 2.0021 0 0128 14zM4 4H3.9985L4 12H28V4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  HorizontalView.propTypes = iconPropTypes;
}
const Hospital = /*#__PURE__*/React.forwardRef(function Hospital(_ref5, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref5;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21 10L17 10 17 6 15 6 15 10 11 10 11 12 15 12 15 16 17 16 17 12 21 12 21 10z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28,10H26V4a2.0023,2.0023,0,0,0-2-2H8A2.0023,2.0023,0,0,0,6,4v6H4a2.0023,2.0023,0,0,0-2,2V30H30V12A2.0023,2.0023,0,0,0,28,10ZM14,28V22h4v6Zm6,0V21a1,1,0,0,0-1-1H13a1,1,0,0,0-1,1v7H4V12H8V4H24v8h4V28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Hospital.propTypes = iconPropTypes;
}
const HospitalBed = /*#__PURE__*/React.forwardRef(function HospitalBed(_ref6, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref6;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25,16H17a2.0023,2.0023,0,0,0-2,2v6H4V14H2V30H4V26H28v4h2V21A5.0059,5.0059,0,0,0,25,16Zm3,8H17V18h8a3.0033,3.0033,0,0,1,3,3Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 17A1.5 1.5 0 118 18.5 1.5017 1.5017 0 019.5 17m0-2A3.5 3.5 0 1013 18.5 3.5 3.5 0 009.5 15zM21 6L17 6 17 2 15 2 15 6 11 6 11 8 15 8 15 12 17 12 17 8 21 8 21 6z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  HospitalBed.propTypes = iconPropTypes;
}
const Hotel = /*#__PURE__*/React.forwardRef(function Hotel(_ref7, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref7;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5,15A1.5,1.5,0,1,1,8,16.5,1.5,1.5,0,0,1,9.5,15m0-2A3.5,3.5,0,1,0,13,16.5,3.5,3.5,0,0,0,9.5,13Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25,14H17a2,2,0,0,0-2,2v6H4V10.6L16,4.14l12.53,6.74.94-1.76-13-7a1,1,0,0,0-.94,0l-13,7A1,1,0,0,0,2,10V30H4V24H28v6h2V19A5,5,0,0,0,25,14Zm-8,8V16h8a3,3,0,0,1,3,3v3Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Hotel.propTypes = iconPropTypes;
}
const Hourglass = /*#__PURE__*/React.forwardRef(function Hourglass(_ref8, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref8;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15 19H17V21H15zM15 23H17V25H15z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M23,11.67V4h3V2H6V4H9v7.67a2,2,0,0,0,.4,1.2L11.75,16,9.4,19.13a2,2,0,0,0-.4,1.2V28H6v2H26V28H23V20.33a2,2,0,0,0-.4-1.2L20.25,16l2.35-3.13A2,2,0,0,0,23,11.67ZM21,4v7H11V4Zm0,16.33V28H11V20.33L14.25,16,12,13h8l-2.25,3Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Hourglass.propTypes = iconPropTypes;
}
const Html = /*#__PURE__*/React.forwardRef(function Html(_ref9, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref9;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M28 19L28 11 26 11 26 21 32 21 32 19 28 19zM24 11L22 11 20.5 15 19 11 17 11 17 21 19 21 19 14 20.5 18 22 14 22 21 24 21 24 11zM9 13L11 13 11 21 13 21 13 13 15 13 15 11 9 11 9 13zM5 11L5 15 2 15 2 11 0 11 0 21 2 21 2 17 5 17 5 21 7 21 7 11 5 11z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Html.propTypes = iconPropTypes;
}
const HtmlReference = /*#__PURE__*/React.forwardRef(function HtmlReference(_ref10, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref10;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM28 14L28 6 26 6 26 16 32 16 32 14 28 14zM24 6L22 6 20.5 10 19 6 17 6 17 16 19 16 19 9 20.5 13 22 9 22 16 24 16 24 6zM9 8L11 8 11 16 13 16 13 8 15 8 15 6 9 6 9 8zM5 6L5 10 2 10 2 6 0 6 0 16 2 16 2 12 5 12 5 16 7 16 7 6 5 6z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  HtmlReference.propTypes = iconPropTypes;
}
const Http = /*#__PURE__*/React.forwardRef(function Http(_ref11, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref11;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M30 11H25V21h2V18h3a2.0027 2.0027 0 002-2V13A2.0023 2.0023 0 0030 11zm-3 5V13h3l.001 3zM10 13L12 13 12 21 14 21 14 13 16 13 16 11 10 11 10 13zM23 11L17 11 17 13 19 13 19 21 21 21 21 13 23 13 23 11zM6 11L6 15 3 15 3 11 1 11 1 21 3 21 3 17 6 17 6 21 8 21 8 11 6 11z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Http.propTypes = iconPropTypes;
}
const Humidity = /*#__PURE__*/React.forwardRef(function Humidity(_ref12, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref12;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4761,13.9932,16.8472,3.4365a1.04,1.04,0,0,0-1.6944,0L8.4941,14.0444A9.9861,9.9861,0,0,0,7,19a9,9,0,0,0,18,0A10.0632,10.0632,0,0,0,23.4761,13.9932ZM16,26.0005a7.0089,7.0089,0,0,1-7-7,7.978,7.978,0,0,1,1.2183-3.9438l.935-1.4888L21.2271,23.6411A6.9772,6.9772,0,0,1,16,26.0005Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Humidity.propTypes = iconPropTypes;
}
const HumidityAlt = /*#__PURE__*/React.forwardRef(function HumidityAlt(_ref13, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref13;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M26 12a3.8978 3.8978 0 01-4-3.777 3.9017 3.9017 0 01.6533-2.0639L25.17 2.4141a1.0381 1.0381 0 011.6592 0L29.3154 6.11A3.9693 3.9693 0 0130 8.223 3.8978 3.8978 0 0126 12zm0-7.2368L24.3438 7.2257A1.89 1.89 0 0024 8.223a2.0139 2.0139 0 004 0 1.98 1.98 0 00-.375-1.0466zM23.5 30H8.5A6.4962 6.4962 0 017.2 17.1381a8.9938 8.9938 0 0117.6006 0A6.4964 6.4964 0 0123.5 30zM16 12a7 7 0 00-6.9414 6.1452l-.0991.8122-.8155.064A4.4962 4.4962 0 008.5 28h15a4.4962 4.4962 0 00.3564-8.9786l-.8154-.064-.0986-.8122A7.0022 7.0022 0 0016 12z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  HumidityAlt.propTypes = iconPropTypes;
}
const Hurricane = /*#__PURE__*/React.forwardRef(function Hurricane(_ref14, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref14;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6521,4.1821l-2.177,2.5142L19.0713,8.3174,20.7864,9.605A7.9361,7.9361,0,0,1,23.9963,16l.0008.0576.0017.0415c.018.4317.2412,10.1113-14.6538,11.7222l2.18-2.5176,1.4039-1.6211L11.2139,22.395A7.9361,7.9361,0,0,1,8.0037,16l-.0008-.0576-.0017-.0415C7.9832,15.47,7.7605,5.8071,22.6521,4.1821M24.9978,2c-.0164,0-.0327,0-.0493.001C5.2532,2.9146,6.0037,16,6.0037,16a9.975,9.975,0,0,0,4.0095,7.9946L6.2368,28.3555A1.0044,1.0044,0,0,0,7.0022,30c.0164,0,.0327,0,.0493-.001C26.7468,29.0854,25.9963,16,25.9963,16a9.9756,9.9756,0,0,0-4.0092-7.9946l3.7761-4.3609A1.0044,1.0044,0,0,0,24.9978,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Hurricane.propTypes = iconPropTypes;
}
const HybridNetworking = /*#__PURE__*/React.forwardRef(function HybridNetworking(_ref15, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref15;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M17,24.1836V20H15v4.1836a3,3,0,1,0,2,0Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M26,12a3.9962,3.9962,0,0,0-3.8579,3H9.8579a4,4,0,1,0,0,2H22.1421A3.9934,3.9934,0,1,0,26,12ZM6,18a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,6,18Zm20,0a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,26,18Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M19,5a3,3,0,1,0-4,2.8164V12h2V7.8164A2.9917,2.9917,0,0,0,19,5Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  HybridNetworking.propTypes = iconPropTypes;
}
const HybridNetworkingAlt = /*#__PURE__*/React.forwardRef(function HybridNetworkingAlt(_ref16, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref16;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M26,22a3.9583,3.9583,0,0,0-2.02.5659L17.4141,16,23.981,9.4331A3.9521,3.9521,0,0,0,26,10a4,4,0,1,0-4-4,3.951,3.951,0,0,0,.5669,2.019L16,14.5859,9.4343,8.02A3.9577,3.9577,0,0,0,10,6a4,4,0,1,0-4,4,3.9583,3.9583,0,0,0,2.02-.5659L14.5859,16,8.019,22.5669A3.9521,3.9521,0,0,0,6,22a4,4,0,1,0,4,4,3.951,3.951,0,0,0-.5669-2.019L16,17.4141,22.5657,23.98A3.9577,3.9577,0,0,0,22,26a4,4,0,1,0,4-4ZM26,4a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,4ZM6,28a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  HybridNetworkingAlt.propTypes = iconPropTypes;
}
const IbmAiOnZ = /*#__PURE__*/React.forwardRef(function IbmAiOnZ(_ref17, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref17;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m28,26c-.7384,0-1.3762.4047-1.7226,1h-5.2774l7.7998-10.4004c.2275-.3027.2642-.708.0947-1.0469s-.5156-.5527-.8945-.5527h-10.1843c-.4141-1.1615-1.5138-2-2.8157-2-1.6543,0-3,1.3457-3,3s1.3457,3,3,3c1.3019,0,2.4016-.8385,2.8157-2h8.1843l-7.7998,10.4004c-.2275.3027-.2642.708-.0947,1.0469s.5156.5527.8945.5527h7.2774c.3464.5953.9842,1,1.7226,1,1.1046,0,2-.8954,2-2s-.8954-2-2-2Zm-13-9c-.5513,0-1-.4482-1-1s.4487-1,1-1,1,.4482,1,1-.4487,1-1,1Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m16,21h-2v4.5859L4.4139,16,14,6.4142v4.5858h2v-6h10v8h2V5c0-1.1046-.8954-2-2-2H4c-1.1046,0-2,.8954-2,2v22c0,1.1046.8954,2,2,2h12v-8ZM4,5h8.5858L4,13.5858V5Zm0,22v-8.5858l8.5858,8.5858H4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmAiOnZ.propTypes = iconPropTypes;
}
const IbmAiopsInsights = /*#__PURE__*/React.forwardRef(function IbmAiopsInsights(_ref18, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref18;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 23L2 30 9 30 5.5 23zM26 15v2c1.1025 0 2 .8975 2 2v5c0 1.1025-.8975 2-2 2H10v2h16c2.2061 0 4-1.7939 4-4v-5c0-2.2056-1.7939-4-4-4z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m14,24c-.4463,0-.8389-.2959-.9614-.7251l-1.793-6.2749h-3.2456v-2h4c.4463,0,.8389.2959.9614.7251l1.0386,3.6348,3.0386-10.6348c.1226-.4292.5151-.7251.9614-.7251s.8389.2959.9614.7251l1.793,6.2749h3.2456v2h-4c-.4463,0-.8389-.2959-.9614-.7251l-1.0386-3.6348-3.0386,10.6348c-.1226.4292-.5151.7251-.9614.7251Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m4,13v-5c0-1.103.897-2,2-2h16v-2H6c-2.2056,0-4,1.7944-4,4v5c0,2.2056,1.7944,4,4,4v-2c-1.103,0-2-.897-2-2Z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: "27",
    cy: "5",
    r: "3"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmAiopsInsights.propTypes = iconPropTypes;
}
const IbmBluepay = /*#__PURE__*/React.forwardRef(function IbmBluepay(_ref19, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref19;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M5 26V15.8281l-3.5859 3.586L0 18l6-6 6 6-1.4141 1.4141-3.5859-3.586v10.1719h12v2H7c-1.104-.0013-1.9987-.896-2-2zM31 18h-3v-2h-2v2h-1c-1.1046 0-2 .8954-2 2v2c0 1.1046.8954 2 2 2h4v2h-6s0 2 0 2h3v2h2v-2h1c1.1046 0 2-.8954 2-2v-2c0-1.1046-.8954-2-2-2h-4v-2h6v-2zM28 12V6c-.0012-1.104-.896-1.9988-2-2H12v2h14v6M2 6H7V8H2zM2 2H10V4H2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmBluepay.propTypes = iconPropTypes;
}
const IbmCloudant = /*#__PURE__*/React.forwardRef(function IbmCloudant(_ref20, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref20;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M16 26h5c3.86 0 7-3.14 7-7v-2h-2v2c0 2.76-2.24 5-5 5h-5v2zM20.25 14c-2.34 0-4.25-1.91-4.25-4.25 0-1.79 1.14-3.38 2.78-3.99.74-2.21 2.84-3.76 5.22-3.76s4.48 1.55 5.22 3.76c1.65.61 2.78 2.19 2.78 3.99 0 2.29-1.86 4.19-4.14 4.25h-7.61zm3.75-10c-1.64 0-3.08 1.17-3.42 2.77l-.14.64-.64.13c-1.04.21-1.8 1.14-1.8 2.2 0 1.24 1.01 2.26 2.25 2.26h7.58c1.18-.03 2.17-1.05 2.17-2.26 0-1.06-.76-1.99-1.8-2.2l-.64-.13-.14-.64c-.34-1.6-1.78-2.77-3.42-2.77zM4 14h2v-2c0-2.76 2.24-5 5-5h4v-2h-4c-3.86 0-7 3.14-7 7v2zM10 17h-6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h6c1.1 0 2-.9 2-2v-10c0-1.1-.9-2-2-2zm0 2v2h-6v-2h6zm0 4v2h-6v-2h6zm-6 6v-2h6v2H4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudant.propTypes = iconPropTypes;
}
const IbmContentServices = /*#__PURE__*/React.forwardRef(function IbmContentServices(_ref21, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref21;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M26,32l-2.1387-1.0117c-1.7383-.8232-2.8613-2.5977-2.8613-4.5205v-6.4678h10v6.4678c0,1.9238-1.123,3.6973-2.8613,4.5195l-2.1387,1.0127Zm-1.2832-2.8203l1.2832,.6074,1.2832-.6074c1.043-.4932,1.7168-1.5576,1.7168-2.7119v-4.4678h-6v4.4678c0,1.1543,.6738,2.2188,1.7168,2.7119h0Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M17,10.5859c-.3752-.375-.8838-.5859-1.4143-.5859h-5.5857c-1.1045,0-2,.8955-2,2v14c0,1.1045,.8955,2,2,2h9v-2H10V12h4v4c0,1.1045,.8955,2,2,2h4.2917c.6929,0,1.312-.4136,1.5771-1.0537,.2656-.6406,.1201-1.3711-.3701-1.8613l-4.4988-4.499Zm-1,5.4141v-3.5859l3.5852,3.5859h-3.5852Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M28,6H16l-3.4141-3.4141c-.3752-.375-.8838-.5859-1.4143-.5859H4c-1.1045,0-2,.8955-2,2V24c0,1.1045,.8955,2,2,2h2v-2H4V4h7.1716l4,4h12.8284v10h2V8c0-1.1045-.8955-2-2-2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmContentServices.propTypes = iconPropTypes;
}
const IbmDataReplication = /*#__PURE__*/React.forwardRef(function IbmDataReplication(_ref22, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref22;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M20 20v2h5.22a11.0163 11.0163 0 01-11.97 4.6533l-.4986 1.937A13 13 0 0026 24.293V28h2V20zM25 3a4.0045 4.0045 0 00-4 4 3.954 3.954 0 00.5669 2.019L9.019 21.5669A3.9521 3.9521 0 007 21a4 4 0 104 4 3.954 3.954 0 00-.5669-2.019L22.981 10.4331A3.9518 3.9518 0 0025 11a4 4 0 000-8zM7 27a2 2 0 112-2A2.002 2.002 0 017 27zM25 9a2 2 0 112-2A2.002 2.002 0 0125 9zM16 3A13.04 13.04 0 006 7.707V4H4v8h8V10H6.78a11.0163 11.0163 0 0111.97-4.6533l.4986-1.937A13.0358 13.0358 0 0016 3z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmDataReplication.propTypes = iconPropTypes;
}
const IbmDatastage = /*#__PURE__*/React.forwardRef(function IbmDatastage(_ref23, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref23;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M27 22.1V13h-2v9.1c-1.4.4-2.5 1.5-2.9 2.9H13v2h9.1c.4 1.7 2 3 3.9 3 2.2 0 4-1.8 4-4C30 24.1 28.7 22.6 27 22.1zM26 28c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2S27.1 28 26 28zM10 30H2v-8h8V30zM4 28h4v-4H4V28zM9.9 7H19V5H9.9C9.4 3.3 7.9 2 6 2 3.8 2 2 3.8 2 6c0 1.9 1.3 3.4 3 3.9V19h2V9.9C8.4 9.5 9.5 8.4 9.9 7zM6 8C4.9 8 4 7.1 4 6s.9-2 2-2 2 .9 2 2S7.1 8 6 8z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M22 2L22 4 26.6 4 11 19.6 12.4 21 28 5.4 28 10 30 10 30 2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmDatastage.propTypes = iconPropTypes;
}
const IbmDb2 = /*#__PURE__*/React.forwardRef(function IbmDb2(_ref24, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref24;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "m16,13c-3.4207,0-6,1.5049-6,3.5v8c0,1.9951,2.5793,3.5,6,3.5s6-1.5049,6-3.5v-8c0-1.9951-2.5793-3.5-6-3.5Zm0,2c2.4814,0,4,.9712,4,1.5s-1.5186,1.5-4,1.5-4-.9712-4-1.5,1.5186-1.5,4-1.5Zm0,11c-2.4814,0-4-.9712-4-1.5v-1.3525c1.0469.5342,2.4331.8525,4,.8525s2.9531-.3184,4-.8525v1.3525c0,.5288-1.5186,1.5-4,1.5Zm0-4c-2.4814,0-4-.9712-4-1.5v-1.3525c1.0469.5342,2.4331.8525,4,.8525s2.9531-.3184,4-.8525v1.3525c0,.5288-1.5186,1.5-4,1.5Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "m30,15.5c0,3.08-2.14,5.65-5.0099,6.3199v-2.0699c1.75-.62,3.0099-2.28,3.0099-4.25,0-2.33-1.83-4.29-4.15-4.4801l-.81-.0599-.1-.8099c-.43-3.5-3.42-6.15-6.94-6.15-3.53,0-6.52,2.65-6.95,6.15l-.1.8099-.81.0599c-2.32.1901-4.14,2.1501-4.14,4.4801,0,1.96,1.25,3.62,2.9901,4.24v2.08c-2.86-.6799-4.9901-3.25-4.9901-6.3199,0-3.1,2.22-5.75,5.2-6.36.86-4.1201,4.52-7.14,8.8-7.14,4.27,0,7.9301,3.0199,8.8,7.14,2.97.61,5.2,3.26,5.2,6.36Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmDb2.propTypes = iconPropTypes;
}
const IbmDb2Alt = /*#__PURE__*/React.forwardRef(function IbmDb2Alt(_ref25, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref25;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3579 22h-8.397v-2.3287l3.6545-3.1277c1.3259-1.1389 1.7849-1.8019 1.7849-2.8047v-.238c0-.9009-.7991-1.3599-1.564-1.3599-1.1218 0-1.6658.7649-1.9038 1.6658l-2.2268-.8499c.5271-1.6488 1.9038-3.0256 4.3687-3.0256 2.5667 0 4.0457 1.5128 4.0457 3.5696 0 2.0398-1.4619 3.2806-3.1619 4.6235l-2.2097 1.7339h5.6094v2.1417zM12.8291 9.4212h2.5159v5.1505h.085c.2549-.986 1.2407-1.6998 2.3967-1.6998 2.2607 0 3.4336 1.6318 3.4336 4.6575s-1.1729 4.6746-3.4336 4.6746c-1.156 0-2.1418-.731-2.3967-1.6998h-.085v1.4958h-2.5159V9.4212zm5.8135 8.8901v-1.5469c0-1.1218-.697-1.8528-1.6489-1.8528s-1.6487.4929-1.6487 1.3088v2.6348c0 .8159.6968 1.3088 1.6487 1.3088s1.6489-.731 1.6489-1.8528zM1.1163 10.1351H5.5867c3.1448 0 5.2185 1.9889 5.2185 5.9325s-2.0737 5.9324-5.2185 5.9324H1.1163V10.1351zm4.4704 9.5687c1.53 0 2.4819-.8329 2.4819-2.7197v-1.8358c0-1.8868-.9519-2.7197-2.4819-2.7197h-1.8867v7.2753h1.8867z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmDb2Alt.propTypes = iconPropTypes;
}
const IbmDb2Warehouse = /*#__PURE__*/React.forwardRef(function IbmDb2Warehouse(_ref26, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref26;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "m22.5039,17.6362l-6-3.5c-.1558-.0908-.3298-.1362-.5039-.1362s-.3481.0454-.5039.1362l-6,3.5c-.3071.1792-.4961.5083-.4961.8638v7c0,.3555.189.6846.4961.8638l6,3.5c.1558.0908.3298.1362.5039.1362s.3481-.0454.5039-.1362l6-3.5c.3071-.1792.4961-.5083.4961-.8638v-7c0-.3555-.189-.6846-.4961-.8638Zm-1.5039,6.1978l-2.5317-1.519c.0132-.1045.0317-.207.0317-.3149,0-1.0225-.6187-1.9014-1.5-2.2881v-2.9707l4,2.333v4.7598Zm-6-7.0928v2.9707c-.8813.3867-1.5,1.2656-1.5,2.2881,0,.1079.0186.2104.0317.3149l-2.5317,1.519v-4.7598l4-2.333Zm1,11.1011l-3.9517-2.3052,2.5071-1.5039c.4087.291.9055.4668,1.4446.4668s1.0359-.1758,1.4446-.4668l2.5071,1.5039-3.9517,2.3052Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "m24.8,9.14c-.87-4.12-4.52-7.14-8.8-7.14s-7.93,3.02-8.8,7.14c-2.97.6-5.2,3.26-5.2,6.36,0,3.07,2.14,5.63,5,6.31v-2.11c-1.74-.62-3-2.24-3-4.2,0-2.33,1.82-4.31,4.14-4.49l.82-.06.1-.81c.43-3.5,3.41-6.14,6.94-6.14s6.51,2.64,6.94,6.14l.1.81.82.06c2.32.19,4.14,2.16,4.14,4.49,0,1.95-1.26,3.59-3,4.21v2.11c2.86-.68,5-3.26,5-6.32,0-3.11-2.23-5.76-5.2-6.36Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmDb2Warehouse.propTypes = iconPropTypes;
}
const IbmEventAutomation = /*#__PURE__*/React.forwardRef(function IbmEventAutomation(_ref27, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref27;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: "4",
    cy: "22",
    r: "2"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "m13.5,30c-3.0586,0-5.9485-1.4867-7.7305-3.9771l1.6265-1.1638c1.4075,1.9667,3.6892,3.1409,6.104,3.1409,3.969,0,7.2578-3.1002,7.4873-7.0579l1.9966.1157c-.2908,5.0143-4.4565,8.9421-9.4839,8.9421Z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: "28",
    cy: "23",
    r: "2"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6411 19.0948l-1.9243-.5449c.188-.6638.2832-1.3535.2832-2.0499 0-4.1355-3.3645-7.5-7.5-7.5-1.0769 0-2.1157.223-3.0876.6628l-.8247-1.822c1.2329-.558 2.5491-.8408 3.9124-.8408 5.2383 0 9.5 4.2617 9.5 9.5 0 .8807-.1208 1.7537-.3589 2.5948zM20.4141 14.5859l-3-3c-.3774-.3779-.8799-.5859-1.4141-.5859s-1.0366.208-1.4143.5859l-2.9998 3c-.3899.3896-.5859.9019-.5859 1.4141s.196 1.0244.5859 1.4141l2.9998 3c.3777.3779.8801.5859 1.4143.5859s1.0366-.208 1.4141-.5859l3-3c.3899-.3896.5859-.9019.5859-1.4141s-.196-1.0244-.5859-1.4141zm-4.4141 4.4141l-3-3 3-3 2.9998 3-2.9998 3z"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "3",
    r: "2"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "m8.0254,19.8821c-3.0999-1.6578-5.0254-4.8696-5.0254-8.3821C3,6.4729,6.9277,2.307,11.9421,2.0161l.1157,1.9966c-3.9578.2297-7.0579,3.5186-7.0579,7.4873,0,2.7732,1.5208,5.3092,3.9688,6.6184l-.9434,1.7637Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmEventAutomation.propTypes = iconPropTypes;
}
const IbmEventEndpointMgmt = /*#__PURE__*/React.forwardRef(function IbmEventEndpointMgmt(_ref28, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref28;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: "29",
    cy: "29",
    r: "2"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M25 30h-8c-1.1028 0-2-.8972-2-2v-4h2v4h8v2zM30 25h-2v-8h-5v-2h5c1.1028 0 2 .8972 2 2v8zM20.4141 14.5859l-3-3c-.3774-.3779-.8799-.5859-1.4141-.5859s-1.0366.208-1.4143.5859l-2.9998 3c-.3899.3896-.5859.9019-.5859 1.4141s.196 1.0244.5859 1.4141l2.9998 3c.3777.3779.8801.5859 1.4143.5859s1.0366-.208 1.4141-.5859l3-3c.3899-.3896.5859-.9019.5859-1.4141s-.196-1.0244-.5859-1.4141zm-4.4141 4.4141l-3-3 3-3 2.9998 3-2.9998 3zM9 17H4c-1.1028 0-2-.8972-2-2V7h2v8h5v2zM17 8h-2V4H7v-2h8c1.1028 0 2 .8972 2 2v4z"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: "3",
    cy: "3",
    r: "2"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmEventEndpointMgmt.propTypes = iconPropTypes;
}
const IbmEventProcessing = /*#__PURE__*/React.forwardRef(function IbmEventProcessing(_ref29, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref29;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "29",
    r: "2"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 30h-2.5v-2h2.5c3.0327 0 5.5-2.4673 5.5-5.5 0-2.5634-1.7395-4.7644-4.23-5.3528l.46-1.9465c3.3972.8026 5.77 3.8042 5.77 7.2993 0 4.1355-3.3645 7.5-7.5 7.5zM20.4141 14.5859l-3-3c-.3774-.3779-.8799-.5859-1.4141-.5859s-1.0366.208-1.4143.5859l-2.9998 3c-.3899.3896-.5859.9019-.5859 1.4141s.196 1.0244.5859 1.4141l2.9998 3c.3777.3779.8801.5859 1.4143.5859s1.0366-.208 1.4141-.5859l3-3c.3899-.3896.5859-.9019.5859-1.4141s-.196-1.0244-.5859-1.4141zm-4.4141 4.4141l-3-3 3-3 2.9998 3-2.9998 3z"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "3",
    r: "2"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "m7.77,16.7993c-3.3972-.8026-5.77-3.8042-5.77-7.2993C2,5.3645,5.3645,2,9.5,2h2.5v2h-2.5c-3.0327,0-5.5,2.4673-5.5,5.5,0,2.5634,1.7395,4.7645,4.23,5.3528l-.46,1.9465Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmEventProcessing.propTypes = iconPropTypes;
}
const IbmEventStreams = /*#__PURE__*/React.forwardRef(function IbmEventStreams(_ref30, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref30;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "m20,27c-2.9795,0-5.7693-1.1719-7.8555-3.2998l1.4282-1.4001c1.7068,1.7411,3.9895,2.7,6.4272,2.7,4.9626,0,9-4.0374,9-9,0-2.3705-.9138-4.6079-2.5732-6.3004l1.4282-1.4001c2.0281,2.0686,3.145,4.8033,3.145,7.7006,0,6.0654-4.9346,11-11,11Z"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: "24",
    cy: "5",
    r: "2"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "m20.4141,14.5859l-3-3c-.3774-.3779-.8799-.5859-1.4141-.5859s-1.0366.208-1.4143.5859l-2.9998,3c-.3899.3896-.5859.9019-.5859,1.4141s.196,1.0244.5859,1.4141l2.9998,3c.3777.3779.8801.5859,1.4143.5859s1.0366-.208,1.4141-.5859l3-3c.3899-.3896.5859-.9019.5859-1.4141s-.196-1.0244-.5859-1.4141Zm-4.4141,4.4141l-3-3,3-3,2.9998,3-2.9998,3Z"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: "8",
    cy: "27",
    r: "2"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "m4.2993,23.855c-2.1277-2.0861-3.2993-4.8757-3.2993-7.855C1,9.9346,5.9346,5,12,5c2.9795,0,5.7693,1.1719,7.8555,3.2998l-1.4282,1.4001c-1.7068-1.7411-3.9895-2.7-6.4272-2.7-4.9626,0-9,4.0374-9,9,0,2.4376.9587,4.7201,2.6997,6.427l-1.4004,1.428Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmEventStreams.propTypes = iconPropTypes;
}
const IbmMatch_360 = /*#__PURE__*/React.forwardRef(function IbmMatch_360(_ref31, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref31;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M5 25a2 2 0 102 2A2.0059 2.0059 0 005 25zM16 25a2 2 0 102 2A2.0059 2.0059 0 0016 25zM27 25a2 2 0 102 2A2.0059 2.0059 0 0027 25zM28 23H26V11a2.0059 2.0059 0 00-2-2H22V7h2a4.0118 4.0118 0 014 4zM15 12H17V23H15zM6 23H4V11A4.0118 4.0118 0 018 7h2V9H8a2.0059 2.0059 0 00-2 2zM16 2L14.7 4.6343l-2.9057.42 2.1029 2.0514L13.4 10 16 8.6343 18.6 10l-.4972-2.8943 2.1029-2.0486L17.3 4.6343z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmMatch_360.propTypes = iconPropTypes;
}
const IbmMq = /*#__PURE__*/React.forwardRef(function IbmMq(_ref32, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref32;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5,28.4l-0.9-1.8c4-2.1,6.5-6.2,6.5-10.6c0-6.6-5.4-12-12-12c-1.3,0-2.5,0.2-3.7,0.6l-0.6-1.9C13.1,2.2,14.5,2,16,2 c7.7,0,14,6.3,14,14C30,21.2,27.1,26,22.5,28.4z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 23.8l-1-1.7c2.2-1.2 3.5-3.6 3.5-6.1 0-3.9-3.1-7-7-7-.6 0-1.2.1-1.8.2l-.5-1.9C14.5 7.1 15.2 7 16 7c5 0 9 4 9 9C25 19.2 23.3 22.2 20.5 23.8zM9.5 28.4C4.9 26 2 21.2 2 16c0-1.5.2-2.9.7-4.3l1.9.6C4.2 13.5 4 14.7 4 16c0 4.5 2.5 8.6 6.5 10.6L9.5 28.4z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5,23.8C8.7,22.2,7,19.2,7,16c0-0.8,0.1-1.5,0.3-2.2l1.9,0.5C9.1,14.8,9,15.4,9,16c0,2.5,1.3,4.8,3.5,6.1L11.5,23.8z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M20,16c0-2.2-1.8-4-4-4c-0.7,0-1.4,0.2-2,0.6L8.9,7.5C9,7.3,9,7.2,9,7c0-1.1-0.9-2-2-2S5,5.9,5,7s0.9,2,2,2 c0.2,0,0.3,0,0.5-0.1l5.1,5.1c-0.4,0.6-0.6,1.3-0.6,2c0,1.9,1.3,3.4,3,3.9v7.4c-0.6,0.3-1,1-1,1.7c0,1.1,0.9,2,2,2s2-0.9,2-2 c0-0.7-0.4-1.4-1-1.7v-7.4C18.7,19.4,20,17.9,20,16z M16,18c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S17.1,18,16,18z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmMq.propTypes = iconPropTypes;
}
const IbmOpenEnterpriseLanguages = /*#__PURE__*/React.forwardRef(function IbmOpenEnterpriseLanguages(_ref33, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref33;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M23.586 21.414L27.166 25 27.166 25 23.584 28.587 25 30 30 25 25 20zM20.414 21.414L16.834 25 16.834 25 20.416 28.587 19 30 14 25 19 20zM22 6H24V14H22zM18 6H20V14H18zM14 14h-2c-1.103 0-2-.897-2-2V8c0-1.103.897-2 2-2h2c1.103 0 2 .897 2 2v4C16 13.103 15.103 14 14 14zM12 8v4h2V8H12zM6 6H8V14H6z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M10,28H4c-1.103,0-2-0.897-2-2V4c0-1.103,0.897-2,2-2h22c1.103,0,2,0.897,2,2v12h-2V4H4v22h6V28z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmOpenEnterpriseLanguages.propTypes = iconPropTypes;
}
const IbmOpenshiftContainerPlatformOnVpcForRegulatedIndustries = /*#__PURE__*/React.forwardRef(function IbmOpenshiftContainerPlatformOnVpcForRegulatedIndustries(_ref34, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref34;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: "19",
    cy: "27",
    r: "1"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M29 31h-13c-1.1028 0-2-.8972-2-2v-4c0-1.1028.8972-2 2-2h13c1.1028 0 2 .8972 2 2v4c0 1.1028-.8972 2-2 2zm-13-6v4h13v-4h-13zM29 21h-13c-1.1028 0-2-.8972-2-2v-4c0-1.1028.8972-2 2-2h13c1.1028 0 2 .8972 2 2v4c0 1.1028-.8972 2-2 2zm-13-6v4h13v-4h-13z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "m12,27.2998c-4.6531-1.6523-8-6.0869-8-11.2998,0-6.6167,5.3833-12,12-12,4.8311,0,8.9937,2.876,10.8945,7h2.1665c-2.0188-5.2544-7.1045-9-13.061-9-7.7197,0-14,6.2803-14,14,0,6.3291,4.2246,11.6846,10,13.4102v-2.1104Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmOpenshiftContainerPlatformOnVpcForRegulatedIndustries.propTypes = iconPropTypes;
}
const IbmPowerVs = /*#__PURE__*/React.forwardRef(function IbmPowerVs(_ref35, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref35;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M16 25c-2 0-4-.7-5.6-2l1.3-1.6c1.3 1 2.8 1.5 4.4 1.5 3.9 0 7-3.1 7-7 0-.3 0-.7-.1-1l2-.3C25 15.1 25 15.6 25 16 25 21 21 25 16 25zM7.1 17.3C7 16.9 7 16.4 7 16c0-5 4-9 9-9 2 0 4 .7 5.6 2l-1.3 1.6C19.1 9.5 17.6 9 16 9c-3.9 0-7 3.1-7 7 0 .3 0 .7.1 1L7.1 17.3z"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "27",
    r: "1"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "20",
    r: "1"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "12",
    r: "1"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "5",
    r: "1"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M16 30C8.3 30 2 23.7 2 16c0-3.7 1.5-7.3 4.1-9.9l1.4 1.4C5.2 9.8 4 12.8 4 16c0 6.6 5.4 12 12 12 1.4 0 2.8-.2 4.1-.7l.7 1.9C19.3 29.7 17.6 30 16 30zM25.9 25.9l-1.4-1.4c2.3-2.3 3.5-5.3 3.5-8.5 0-6.6-5.4-12-12-12-1.4 0-2.8.2-4.1.7l-.7-1.9C12.7 2.3 14.4 2 16 2c7.7 0 14 6.3 14 14C30 19.7 28.5 23.3 25.9 25.9z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmPowerVs.propTypes = iconPropTypes;
}
const IbmPowerVsPrivateCloud = /*#__PURE__*/React.forwardRef(function IbmPowerVsPrivateCloud(_ref36, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref36;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M23 26H25V30H23z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "m28,21.5859l-3.293-3.293c-.1953-.1953-.4512-.293-.707-.293s-.5117.0977-.707.293l-5,5c-.1875.1875-.293.4414-.293.707v6h2v-5.5859l4-4,4,4v5.5859h2v-10h-2v1.5859Z"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "20",
    r: "1"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "12",
    r: "1"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "5",
    r: "1"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "m9,16c0-3.8598,3.1402-7,7-7,1.7023,0,3.2635.6121,4.4783,1.6261l1.2822-1.5386c-1.561-1.3023-3.5685-2.0875-5.7604-2.0875-4.9706,0-9,4.0294-9,9,0,.5231.0541,1.0327.1398,1.5313l1.9693-.3404c-.0669-.3879-.1091-.7842-.1091-1.1909Z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M4 16c0-3.3084 1.3457-6.3084 3.5186-8.4813l-1.4182-1.4182c-2.5335 2.5335-4.1005 6.0334-4.1005 9.8994 0 7.732 6.268 14 14 14v-2c-6.6168 0-12-5.3832-12-12zM16 4c6.6168 0 12 5.3832 12 12h2c0-7.732-6.268-14-14-14-1.6813 0-3.2861.3116-4.7795.855l.6837 1.8803c1.2804-.4672 2.6558-.7353 4.0959-.7353z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmPowerVsPrivateCloud.propTypes = iconPropTypes;
}
const IbmPowerWithVpc = /*#__PURE__*/React.forwardRef(function IbmPowerWithVpc(_ref37, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref37;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M9 21H3c-1.1028 0-2-.8972-2-2v-6c0-1.1028.8972-2 2-2h6c1.1028 0 2 .8972 2 2v6c0 1.1028-.8972 2-2 2zm-6-8v6h6v-6H3zM11.6926 29.3245c-3.0789-.9945-5.7393-3.0491-7.4912-5.7853l1.6846-1.0784c1.5022 2.3466 3.7827 4.1082 6.4214 4.9606l-.6147 1.9031z"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: "19",
    cy: "27",
    r: "1"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M29 31h-13c-1.1028 0-2-.8972-2-2v-4c0-1.1028.8972-2 2-2h13c1.1028 0 2 .8972 2 2v4c0 1.1028-.8972 2-2 2zm-13-6v4h13v-4h-13zM26.8896 21h2.1848c.6057-1.5889.9255-3.29.9255-5 0-.6719-.0642-1.3384-.1592-2h-2.0269c.1106.6592.186 1.3262.186 2 0 1.7549-.3867 3.4297-1.1104 5zM28 7c0-.3701-.0669-.7212-.1611-1.0615l1.8574-1.0723-1-1.7324-1.8467 1.0664c-.5-.5088-1.1384-.873-1.8496-1.0581V1h-2v2.1421c-.7112.1851-1.3496.5493-1.8496 1.0581l-1.8467-1.0664-1 1.7324 1.8574 1.0723c-.0942.3403-.1611.6914-.1611 1.0615s.0669.7212.1611 1.0615l-1.8574 1.0723 1 1.7324 1.8467-1.0664c.5.5088 1.1394.8721 1.8496 1.0576v2.1426h2v-2.1426c.7102-.1855 1.3496-.5488 1.8496-1.0576l1.8467 1.0664 1-1.7324-1.8574-1.0723c.0942-.3403.1611-.6914.1611-1.0615zm-4 2c-1.1028 0-2-.8975-2-2s.8972-2 2-2 2 .8975 2 2-.8972 2-2 2zM5.886 9.5392l-1.6846-1.0784C6.7915 4.4153 11.2021 2 16 2v2c-4.1125 0-7.8936 2.0707-10.114 5.5392z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmPowerWithVpc.propTypes = iconPropTypes;
}
const IbmPrivatePathServices = /*#__PURE__*/React.forwardRef(function IbmPrivatePathServices(_ref38, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref38;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "m24,16c-1.3019,0-2.4016.8385-2.8157,2h-9.1843v-2h-6v6h6v-2h9.1843c.4141,1.1615,1.5137,2,2.8157,2,1.6543,0,3-1.3457,3-3s-1.3457-3-3-3Zm-14,4h-2v-2h2v2Zm14,0c-.5518,0-1-.4482-1-1s.4482-1,1-1,1,.4482,1,1-.4482,1-1,1Z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "m25.8321,11.22c-.8432-4.6665-4.9267-8.22-9.8321-8.22S7.0109,6.5535,6.1678,11.22c-3.5296.8317-6.1678,4.0001-6.1678,7.78,0,4.4111,3.5889,8,8,8h4v-2h-4c-3.3086,0-6-2.6914-6-6s2.6914-6,6-6c0-4.4111,3.5889-8,8-8s8,3.5889,8,8c3.3086,0,6,2.6914,6,6s-2.6914,6-6,6h-8v2h8c4.4111,0,8-3.5889,8-8,0-3.7799-2.6382-6.9484-6.1679-7.78Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmPrivatePathServices.propTypes = iconPropTypes;
}
const IbmProcessMining = /*#__PURE__*/React.forwardRef(function IbmProcessMining(_ref39, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref39;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "m26,22c-1.8584,0-3.4106,1.2798-3.8579,3h-12.2842c-.3635-1.3984-1.4629-2.4927-2.8579-2.8579v-3.1421c0-1.1025.8972-2,2-2h14c2.2056,0,4-1.7944,4-4v-3.1421c1.7202-.4473,3-1.9995,3-3.8579,0-2.2056-1.7944-4-4-4s-4,1.7944-4,4c0,1.8584,1.2798,3.4106,3,3.8579v3.1421c0,1.1025-.8972,2-2,2h-14c-2.2056,0-4,1.7944-4,4v3.1421c-1.7202.4473-3,1.9995-3,3.8579,0,2.2056,1.7944,4,4,4,1.8584,0,3.4106-1.2798,3.8579-3h12.2842c.4473,1.7202,1.9995,3,3.8579,3,2.2056,0,4-1.7944,4-4s-1.7944-4-4-4Zm-2-16c0-1.1025.8972-2,2-2s2,.8975,2,2-.8972,2-2,2-2-.8975-2-2ZM6,28c-1.1028,0-2-.8975-2-2s.8972-2,2-2,2,.8975,2,2-.8972,2-2,2Zm20,0c-1.1028,0-2-.8975-2-2s.8972-2,2-2,2,.8975,2,2-.8972,2-2,2Z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "m6,10c.7395,0,1.4241-.2153,2.019-.5669l3.5669,3.5669,1.4141-1.4141-3.5669-3.5669c.3516-.5947.5669-1.2798.5669-2.019,0-2.2056-1.7944-4-4-4S2,3.7944,2,6s1.7944,4,4,4Zm0-6c1.1028,0,2,.8975,2,2s-.8972,2-2,2-2-.8975-2-2,.8972-2,2-2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmProcessMining.propTypes = iconPropTypes;
}
const IbmSaasConsole = /*#__PURE__*/React.forwardRef(function IbmSaasConsole(_ref40, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref40;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: "30",
    cy: "20",
    r: "1"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: "2",
    cy: "20",
    r: "1"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "m24,26c-2.2165,0-4.1514-1.2112-5.1903-3.0034l-1.7326,1.0002c1.3834,2.3906,3.9622,4.0032,6.9229,4.0032s5.5395-1.6125,6.9229-4.0032l-1.7326-1.0002c-1.0389,1.7922-2.9738,3.0034-5.1903,3.0034Z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "m24,14c2.1357,0,4.127,1.1494,5.1973,3l1.7314-1.001c-1.4263-2.4668-4.0815-3.999-6.9287-3.999s-5.5024,1.5322-6.938,4.0151l-3.8647,6.9849c-1.0703,1.8506-3.0615,3-5.1973,3s-4.127-1.1494-5.1973-3l-1.7314,1.001c1.4263,2.4668,4.0815,3.999,6.9287,3.999s5.5024-1.5322,6.938-4.0151l3.8647-6.9849c1.0703-1.8506,3.0615-3,5.1973-3Z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14c2.2165 0 4.1514 1.2112 5.1903 3.0034l1.7326-1.0002c-1.3834-2.3906-3.9622-4.0032-6.9229-4.0032s-5.5395 1.6125-6.9229 4.0032l1.7326 1.0002c1.0389-1.7922 2.9738-3.0034 5.1903-3.0034zM16 6c2.7571 0 5.2571 1.1216 7.0678 2.9321l1.4135-1.4133c-2.1729-2.1731-5.1729-3.5188-8.4813-3.5188s-6.3083 1.3457-8.4813 3.5188l1.4135 1.4133c1.8107-1.8105 4.3107-2.9321 7.0678-2.9321z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmSaasConsole.propTypes = iconPropTypes;
}
const IbmSapOnPower = /*#__PURE__*/React.forwardRef(function IbmSapOnPower(_ref41, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref41;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M9 21H3c-1.1028 0-2-.8972-2-2v-6c0-1.1028.8972-2 2-2h6c1.1028 0 2 .8972 2 2v6c0 1.1028-.8972 2-2 2zM3 13v6h6v-6s-6 0-6 0zM11.6926 29.3245c-3.0789-.9945-5.7393-3.0491-7.4912-5.7853l1.6846-1.0784c1.5022 2.3466 3.7827 4.1082 6.4214 4.9606l-.6147 1.9031z"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: "19",
    cy: "27",
    r: "1"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M29 31h-13c-1.1028 0-2-.8972-2-2v-4c0-1.1028.8972-2 2-2h13c1.1028 0 2 .8972 2 2v4c0 1.1028-.8972 2-2 2zm-13-6v4h13v-4s-13 0-13 0zM26.8896 21h2.1848c.6057-1.5889.9255-3.29.9255-5 0-.6719-.0642-1.3384-.1592-2h-2.0269c.1106.6592.186 1.3262.186 2 0 1.7549-.3867 3.4297-1.1104 5zM25.5 12h-6.5c-.5522 0-1-.4478-1-1V4c0-.5522.4478-1 1-1h12c.3828 0 .7319.2185.8994.5629.0675.1389.1006.2884.1006.4371 0 .22-.0725.4382-.2136.6178l-5.5 7c-.1897.2413-.4795.3822-.7864.3822zm-5.5-2h5.0139l3.9287-5h-8.9426v5zM5.886 9.5392l-1.6846-1.0784C6.7915 4.4153 11.2021 2 16 2v2c-4.1125 0-7.8936 2.0707-10.114 5.5392z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmSapOnPower.propTypes = iconPropTypes;
}
const IbmSecureInfrastructureOnVpcForRegulatedIndustries = /*#__PURE__*/React.forwardRef(function IbmSecureInfrastructureOnVpcForRegulatedIndustries(_ref42, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref42;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M9 21H3c-1.1028 0-2-.8972-2-2v-6c0-1.1028.8972-2 2-2h6c1.1028 0 2 .8972 2 2v6c0 1.1028-.8972 2-2 2zM3 13v6h6v-6s-6 0-6 0zM16 30c-.3618 0-.7205-.0138-1.0757-.0406-4.3528-.3312-8.3611-2.7313-10.7229-6.4202l1.6846-1.0784c2.0247 3.1628 5.4602 5.2205 9.1899 5.5043.3047.0231.613.0349.9241.0349v2zM23 30l-2.1-1c-1.7-.8-2.9-2.6-2.9-4.5v-6.5h10v6.5c0 1.9-1.1 3.7-2.9 4.5l-2.1 1zm-3-10v4.5c0 1.2.7 2.2 1.7 2.7l1.3.6 1.3-.6c1-.5 1.7-1.6 1.7-2.7v-4.5h-6zM27.3025 12c.4539 1.2817.6975 2.6211.6975 4h2c0-1.3691-.1987-2.7085-.584-4h-2.1135zM27 10h-3c-1.1028 0-2-.8972-2-2v-3c0-1.1028.8972-2 2-2h3c1.1028 0 2 .8972 2 2v3c0 1.1028-.8972 2-2 2zm-3-5v3h3v-3h-3zM20 2.5835c-1.2915-.3853-2.6309-.5835-4-.5835-4.7976 0-9.2083 2.415-11.7983 6.4604l1.6841 1.0786c2.2209-3.4683 6.002-5.5391 10.1143-5.5391 1.3787 0 2.7188.2437 4 .6978v-2.1143z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmSecureInfrastructureOnVpcForRegulatedIndustries.propTypes = iconPropTypes;
}
const IbmTelehealth = /*#__PURE__*/React.forwardRef(function IbmTelehealth(_ref43, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref43;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M18 25L15 25 15 22 13 22 13 25 10 25 10 27 13 27 13 30 15 30 15 27 18 27 18 25z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M22 30h-2v-5c0-2.8-2.2-5-5-5h-6c-2.8 0-5 2.2-5 5v5H2v-5c0-3.9 3.1-7 7-7h6c3.9 0 7 3.1 7 7v5zM28 5.2V3c0-1.1-.9-2-2-2h-8c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2v-2.2l3 2.2V3l-3 2.2zm-2 3.8h-8V3h8v6zM15.5 12.5c-.9.9-2.1 1.5-3.5 1.5-2.8 0-5-2.2-5-5s2.2-5 5-5c.5 0 .9.1 1.3.2l.6-1.9c-.6-.2-1.2-.3-1.9-.3-3.9 0-7 3.1-7 7s3.1 7 7 7c1.9 0 3.7-.8 5-2l-1.5-1.5z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmTelehealth.propTypes = iconPropTypes;
}
const IbmTenet = /*#__PURE__*/React.forwardRef(function IbmTenet(_ref44, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref44;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M20,13H12c-.5522,0-1,.4478-1,1,0,.1973,.0508,.3833,.168,.5547l4,6c.1855,.2783,.4978,.4453,.832,.4453s.6465-.167,.832-.4453l4-6c.1172-.1714,.168-.3574,.168-.5547,0-.5522-.4478-1-1-1Zm-4,5.1973l-2.1316-3.1973h4.2632l-2.1316,3.1973Z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M16,23c-1.6115,0-3.1763-.5632-4.4205-1.5796l-1.4196,1.4197c.0306,.0261,.057,.0559,.0881,.0818,1.6104,1.3403,3.6523,2.0781,5.752,2.0781,4.9629,0,9-4.0376,9-9h-2c0,3.8599-3.1406,7-7,7Z"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "12",
    r: "1"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "20",
    r: "1"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M16,9c1.6097,0,3.1772,.5619,4.4224,1.5776l1.4171-1.4171c-.0385-.0328-.0718-.0702-.111-.1024-1.6074-1.3271-3.6416-2.0581-5.7285-2.0581-4.9629,0-9,4.0376-9,9h2c0-3.8599,3.1406-7,7-7Z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30c-7.7197,0-14-6.2804-14-14S8.2803,2,16,2s14,6.2804,14,14-6.2803,14-14,14Zm0-26c-6.6167,0-12,5.3832-12,12s5.3833,12,12,12,12-5.3832,12-12-5.3833-12-12-12Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmTenet.propTypes = iconPropTypes;
}
const IbmToolchain = /*#__PURE__*/React.forwardRef(function IbmToolchain(_ref45, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref45;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M25 21c-.7396 0-1.4241.2155-2.0191.5669l-2.0314-2.0314-1.4141 1.4141 2.0314 2.0314c-.3514.595-.5668 1.2795-.5668 2.019 0 2.2056 1.7944 4 4 4 .3557 0 .6943-.0615 1.0228-.1492l-2.4368-2.4368.0004-.0005c-.3621-.3621-.5864-.8621-.5864-1.4136 0-1.103.897-2 2-2 .5515 0 1.0515.2242 1.4136.5864l.0004-.0005 2.4368 2.4368c.0875-.3284.1491-.667.1491-1.0227 0-2.2056-1.7944-4-4-4zM20.9495 12.4644l3.7645-3.7645c.3911.1868.8237.3 1.2861.3 1.6569 0 3-1.3431 3-3s-1.3431-3-3-3-3 1.3431-3 3c0 .4622.1132.8948.2999 1.2859l-3.7645 3.7645 1.4141 1.4141zm5.0505-7.4644c.5514 0 1 .4486 1 1s-.4486 1-1 1-1-.4486-1-1 .4486-1 1-1zM16 12c-2.2092 0-4 1.7908-4 4 0 .7405.215 1.4254.5657 2.0201l-5.2795 5.2799c-.3911-.1868-.8238-.3-1.2861-.3-1.6569 0-3 1.3431-3 3s1.3431 3 3 3 3-1.3431 3-3c0-.4622-.1132-.8948-.2999-1.2858l5.2799-5.2799c.5948.3507 1.2795.5657 2.02.5657 2.2091 0 4-1.7909 4-4s-1.7909-4-4-4zM6 27c-.5514 0-1-.4486-1-1s.4486-1 1-1 1 .4486 1 1-.4486 1-1 1zm10-9c-1.1028 0-2-.8972-2-2s.8972-2 2-2 2 .8972 2 2-.8972 2-2 2zM7 11c.7396 0 1.4241-.2155 2.0191-.5669l2.0311 2.0311 1.4141-1.4141-2.0311-2.0311c.3514-.595.5668-1.2795.5668-2.019 0-2.2056-1.7944-4-4-4-.3557 0-.6943.0615-1.0228.1492l2.4368 2.4368-.0004.0005c.3621.3621.5864.8621.5864 1.4136 0 1.103-.897 2-2 2-.5515 0-1.0515-.2242-1.4136-.5864l-.0004.0005-2.4368-2.4368c-.0875.3284-.1491.667-.1491 1.0227 0 2.2056 1.7944 4 4 4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmToolchain.propTypes = iconPropTypes;
}
const IbmTurbonomic = /*#__PURE__*/React.forwardRef(function IbmTurbonomic(_ref46, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref46;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "m28.8,23.4c-1,2.3-6,4.6-12.8,4.6-7.7,0-13-2.9-13-5.5,0-2.1,3.6-4.5,9.1-5.2l-.3-2c-6.3.9-10.8,3.7-10.8,7.2,0,4.2,6.6,7.5,15,7.5,7.1,0,12.9-2.4,14.5-5.6l-1.7-1Z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "m24.5,20.9c-1.2,1-4.2,2.1-8.5,2.1s-7.3-1.1-8.5-2.1l-1.8,1c1.7,2,6.1,3.1,10.2,3.1,4.2,0,8.5-1.1,10.2-3.1l-1.6-1Z"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "m16,7c-4.2,0-8.5,1.1-10.2,3.1l1.8,1c1.1-1,4.2-2.1,8.4-2.1s7.3,1.1,8.5,2.1l1.8-1c-1.8-2-6.1-3.1-10.3-3.1Z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "m31,9.5c0-4.2-6.6-7.5-15-7.5C8.9,2,3.1,4.4,1.5,7.6l1.7,1c1-2.3,6-4.6,12.8-4.6,7.7,0,13,2.9,13,5.5,0,2.1-3.6,4.5-9.1,5.2l.3,2c6.3-.9,10.8-3.7,10.8-7.2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmTurbonomic.propTypes = iconPropTypes;
}
const IbmVpnForVpc = /*#__PURE__*/React.forwardRef(function IbmVpnForVpc(_ref47, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref47;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M29 23v-2c0-1.6499-1.3501-3-3-3s-3 1.3501-3 3v2c-1.1001 0-2 .8999-2 2v4c0 1.1001.8999 2 2 2h6c1.1001 0 2-.8999 2-2v-4c0-1.1001-.8999-2-2-2zm-4-2c0-.5498.45-1 1-1s1 .4502 1 1v2h-2v-2zm4 8h-6v-4h6v4zM7 22.14v-9.14h-2v9.14c-1.72.45-3 2-3 3.86 0 2.21 1.79 4 4 4 1.86 0 3.41-1.28 3.86-3h8.14v-2h-8.14c-.37-1.4-1.46-2.49-2.86-2.86zm-1 5.86c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM30 6c0-2.21-1.79-4-4-4-1.86 0-3.41 1.28-3.86 3h-9.14v2h9.14c.37 1.4 1.46 2.49 2.86 2.86v5.14h2v-5.14c1.72-.45 3-2 3-3.86zm-4 2c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "m10,8.5898V2H2v8h6.5901l10.9958,11,1.4141-1.4141-11-10.9961Zm-2-.5898h-4v-4h4v4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmVpnForVpc.propTypes = iconPropTypes;
}
const IbmVsiOnVpcForRegulatedIndustries = /*#__PURE__*/React.forwardRef(function IbmVsiOnVpcForRegulatedIndustries(_ref48, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref48;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M9 21H3c-1.1028 0-2-.8972-2-2v-6c0-1.1028.8972-2 2-2h6c1.1028 0 2 .8972 2 2v6c0 1.1028-.8972 2-2 2zM3 13v6h6v-6s-6 0-6 0zM16 30c-.3618 0-.7205-.0138-1.0757-.0406-4.3528-.3312-8.3611-2.7313-10.7229-6.4202l1.6846-1.0784c2.0247 3.1628 5.4602 5.2205 9.1899 5.5043.3047.0231.613.0349.9241.0349v2zM28 30h-8c-1.1028 0-2-.8972-2-2v-8c0-1.1028.8972-2 2-2h8c1.1028 0 2 .8972 2 2v8c0 1.1028-.8972 2-2 2zm-8-10v8h8v-8h-8zM27.3025 12c.4539 1.2817.6975 2.6211.6975 4h2c0-1.3691-.1987-2.7085-.584-4h-2.1135zM27 10h-3c-1.1028 0-2-.8972-2-2v-3c0-1.1028.8972-2 2-2h3c1.1028 0 2 .8972 2 2v3c0 1.1028-.8972 2-2 2zm-3-5v3h3v-3h-3zM20 2.5835c-1.2915-.3853-2.6309-.5835-4-.5835-4.7976 0-9.2083 2.415-11.7983 6.4604l1.6841 1.0786c2.2209-3.4683 6.002-5.5391 10.1143-5.5391 1.3787 0 2.7188.2437 4 .6978v-2.1143z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmVsiOnVpcForRegulatedIndustries.propTypes = iconPropTypes;
}
const IbmWaziDeploy = /*#__PURE__*/React.forwardRef(function IbmWaziDeploy(_ref49, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref49;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "m13.9998,29.991l-10.5037-6.1272c-.3071-.1792-.4961-.5081-.4961-.8638v-14h2v13.4257l10.0076,5.8378-1.0078,1.7275Z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M7 6H9V16H7zM29 13h-2v-3.4257l-11-6.4166-3 1.7499v8.0924h-2V4.3333c0-.3557.189-.6846.4961-.8638l4-2.3333c.1558-.0908.3298-.1362.5039-.1362s.3481.0454.5039.1362l12 7c.3071.1792.4961.5081.4961.8638v4zM27 23l-1.4199 1.4102 1.5898 1.5898h-7.1699v-3.1421c1.7202-.4473 3-1.9995 3-3.8579 0-2.2056-1.7944-4-4-4s-4 1.7944-4 4c0 1.8584 1.2798 3.4106 3 3.8579v3.1421c0 1.1025.8972 2 2 2h7.1699l-1.5798 1.5801 1.4099 1.4199 4-4-4-4zm-10-4c0-1.1025.8972-2 2-2s2 .8975 2 2-.8972 2-2 2-2-.8975-2-2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmWaziDeploy.propTypes = iconPropTypes;
}
const IbmCloud = /*#__PURE__*/React.forwardRef(function IbmCloud(_ref50, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref50;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5805 13.65A9.7327 9.7327 0 006.286 17.5387 6.75 6.75 0 007 31H23a8.7465 8.7465 0 001.5805-17.35zM23 29.5H7a5.2373 5.2373 0 01-.6993-10.4293 9.7265 9.7265 0 001.1036 3.7838.75.75 0 101.3213-.709A8.25 8.25 0 0122.752 13.5133a8.754 8.754 0 00-6.315 2.95.75.75 0 101.1245.9922A7.25 7.25 0 1123 29.5zM31.8983 10.2548a.7582.7582 0 00-1.0364-.2776l-3.02 1.7438A.7587.7587 0 1028.6 13.035l3.02-1.7438A.7589.7589 0 0031.8983 10.2548zM22.6764 7.87a.7583.7583 0 001.0364-.2776l1.7438-3.02a.7587.7587 0 00-1.314-.7588l-1.7438 3.02A.7588.7588 0 0022.6764 7.87zM16 6.0811a.759.759 0 00.7588-.7588V1.8347a.7588.7588 0 10-1.5175 0V5.3223A.7589.7589 0 0016 6.0811zM8.2873 7.5922a.7587.7587 0 001.314-.7588l-1.7438-3.02a.7587.7587 0 10-1.314.7588zM4.1585 11.721l-3.02-1.7438a.7587.7587 0 10-.7588 1.314L3.4 13.035a.7587.7587 0 10.7588-1.314z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloud.propTypes = iconPropTypes;
}
const IbmCloudAppId = /*#__PURE__*/React.forwardRef(function IbmCloudAppId(_ref51, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref51;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M20 18h-6c-1.6569 0-3 1.3431-3 3v2h2v-2c0-.5523.4477-1 1-1h6c.5523 0 1 .4477 1 1v2h2v-2c0-1.6569-1.3431-3-3-3zM17 17c2.2091 0 4-1.7909 4-4s-1.7909-4-4-4-4 1.7909-4 4 1.7909 4 4 4zm0-6c1.1046 0 2 .8954 2 2s-.8954 2-2 2-2-.8954-2-2 .8954-2 2-2z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M17 30c-7.7197 0-14-6.2804-14-14h2c0 6.6168 5.3831 12 12 12 5.2263 0 9.8162-3.3385 11.4214-8.3074l1.9033.6147c-1.873 5.7975-7.2278 9.6926-13.3247 9.6926zM31 16h-2c0-6.6168-5.3833-12-12-12V2c7.7197 0 14 6.2804 14 14zM6 14l-2.1387-1.0127c-1.7383-.8223-2.8613-2.5967-2.8613-4.5195V2H11v6.4678c0 1.9229-1.123 3.6973-2.8613 4.5195l-2.1387 1.0127zM3 4v4.4678c0 1.1533.6738 2.2178 1.7168 2.7109l1.2832.6074 1.2832-.6074c1.043-.4932 1.7168-1.5576 1.7168-2.7109V4H3z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudAppId.propTypes = iconPropTypes;
}
const IbmCloudBareMetalServer = /*#__PURE__*/React.forwardRef(function IbmCloudBareMetalServer(_ref52, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref52;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "26",
    r: "1"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "m26,30H6c-1.1041-.0012-1.9988-.8959-2-2v-4c.0012-1.1041.8959-1.9988,2-2h20c1.1041.0012,1.9988.8959,2,2v4c-.0012,1.1041-.8959,1.9988-2,2Zm-20-6v4h20v-4H6Z"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "16",
    r: "1"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "m26,20H6c-1.1041-.0012-1.9988-.8959-2-2v-4c.0012-1.1041.8959-1.9988,2-2h20c1.1041.0012,1.9988.8959,2,2v4c-.0012,1.1041-.8959,1.9988-2,2ZM6,14v4h20v-4H6Z"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "6",
    r: "1"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "m26,10H6c-1.1041-.0012-1.9988-.8959-2-2v-4c.0012-1.1041.8959-1.9988,2-2h20c1.1041.0012,1.9988.8959,2,2v4c-.0012,1.1041-.8959,1.9988-2,2ZM6,4v4h20v-4H6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudBareMetalServer.propTypes = iconPropTypes;
}
const IbmCloudBareMetalServersVpc = /*#__PURE__*/React.forwardRef(function IbmCloudBareMetalServersVpc(_ref53, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref53;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "26",
    r: "1"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M4 24v4c0 1.1.9 2 2 2h12v-2H6v-4h12v-2H6c-1.1 0-2 .9-2 2zM4 13v5c0 1.1.9 2 2 2h8v-2H6v-5h-2z"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "16",
    r: "1"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M28 19v-5c0-1.1-.9-2-2-2h-8v2h8v5h2zM28 8v-4c0-1.1-.9-2-2-2h-12v2h12v4h-12v2h12c1.1 0 2-.9 2-2z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "m23.41,22l-13.41-13.41V2H2v8h6.59l13.41,13.41v6.59h8v-8h-6.59Zm-15.41-14h-4v-4h4v4Zm20,20h-4v-4h4v4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudBareMetalServersVpc.propTypes = iconPropTypes;
}
const IbmCloudCitrixDaas = /*#__PURE__*/React.forwardRef(function IbmCloudCitrixDaas(_ref54, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref54;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M19 23H23V27H19zM26 23H30V27H26zM19 16H23V20H19zM26 16H30V20H26z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M16,4c-4.3,0-7.9,3-8.8,7.1c-3,0.6-5.2,3.3-5.2,6.4C2,21.1,4.9,24,8.5,24H16v-2H8.5C6,22,4,20,4,17.5c0-2.3,1.8-4.3,4.1-4.5 L9,13l0.1-0.8C9.5,8.6,12.5,6,16,6c3.9,0,7,3.1,7,7h2C25,8,21,4,16,4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudCitrixDaas.propTypes = iconPropTypes;
}
const IbmCloudContinuousDelivery = /*#__PURE__*/React.forwardRef(function IbmCloudContinuousDelivery(_ref55, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref55;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M23,1l-6,6,1.4146,1.4023,3.5854-3.584V21H10V10h-2v11c0,1.1025,.8972,2,2,2h12c1.1028,0,2-.8975,2-2V4.8154l3.5859,3.5869,1.4141-1.4023L23,1Z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 19h-5c-.8271 0-1.5-.6729-1.5-1.5v-5c0-.8271.6729-1.5 1.5-1.5h5c.8271 0 1.5.6729 1.5 1.5v5c0 .8271-.6729 1.5-1.5 1.5zm-4.5-2h4v-4h-4v4zM16 31v-2c7.1682 0 13-5.8318 13-13 0-1.2648-.1812-2.5145-.5383-3.7147l1.917-.5706c.4124 1.3855.6213 2.8273.6213 4.2853 0 8.271-6.729 15-15 15zM1.6213 20.2853c-.4124-1.3855-.6213-2.8273-.6213-4.2853C1 7.729 7.729 1 16 1V3c-7.1682 0-13 5.8318-13 13 0 1.2648.1812 2.5145.5383 3.7147l-1.917.5706z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudContinuousDelivery.propTypes = iconPropTypes;
}
const IbmCloudDedicatedHost = /*#__PURE__*/React.forwardRef(function IbmCloudDedicatedHost(_ref56, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref56;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "6",
    r: "1"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M26 2H6A2 2 0 004 4V8a2 2 0 002 2h9v4h2V10h9a2 2 0 002-2V4A2 2 0 0026 2zm0 6H6V4H26zM17 28L17 26 15 26 15 28 4 28 4 30 28 30 28 28 17 28z"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "20",
    r: "1"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M6,24H26a2,2,0,0,0,2-2V18a2,2,0,0,0-2-2H6a2,2,0,0,0-2,2v4A2,2,0,0,0,6,24Zm0-6H26v4H6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudDedicatedHost.propTypes = iconPropTypes;
}
const IbmCloudDirectLink_1Connect = /*#__PURE__*/React.forwardRef(function IbmCloudDirectLink_1Connect(_ref57, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref57;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M27,29H13c-1.1,0-2-0.9-2-2v-4h2v4h14V13h-4v-2h4c1.1,0,2,0.9,2,2v14C29,28.1,28.1,29,27,29z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M20,17c-0.5,0-0.9,0.1-1.3,0.3l-4-4c0.2-0.4,0.3-0.8,0.3-1.3c0-1.7-1.3-3-3-3s-3,1.3-3,3s1.3,3,3,3c0.5,0,0.9-0.1,1.3-0.3 l4,4C17.1,19.1,17,19.5,17,20c0,1.7,1.3,3,3,3s3-1.3,3-3S21.7,17,20,17z M11,12c0-0.6,0.4-1,1-1s1,0.4,1,1s-0.4,1-1,1S11,12.6,11,12 z M20,21c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S20.6,21,20,21z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M5,3h14c1.1,0,2,0.9,2,2v4h-2V5H5v14h4v2H5c-1.1,0-2-0.9-2-2V5C3,3.9,3.9,3,5,3z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudDirectLink_1Connect.propTypes = iconPropTypes;
}
const IbmCloudDirectLink_1Dedicated = /*#__PURE__*/React.forwardRef(function IbmCloudDirectLink_1Dedicated(_ref58, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref58;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M27,29H13c-1.1,0-2-0.9-2-2v-4h2v4h14V13h-4v-2h4c1.1,0,2,0.9,2,2v14C29,28.1,28.1,29,27,29z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M19,21h-6c-1.1,0-2-0.9-2-2v-6c0-1.1,0.9-2,2-2h6c1.1,0,2,0.9,2,2v6C21,20.1,20.1,21,19,21z M13,13v6h6l0-6H13z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M5,3h14c1.1,0,2,0.9,2,2v4h-2V5H5v14h4v2H5c-1.1,0-2-0.9-2-2V5C3,3.9,3.9,3,5,3z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudDirectLink_1Dedicated.propTypes = iconPropTypes;
}
const IbmCloudDirectLink_1DedicatedHosting = /*#__PURE__*/React.forwardRef(function IbmCloudDirectLink_1DedicatedHosting(_ref59, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref59;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M27,29H13c-1.1,0-2-0.9-2-2v-4h2v4h14V13h-4v-2h4c1.1,0,2,0.9,2,2v14C29,28.1,28.1,29,27,29z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M11 19H21V21H11zM11 15H21V17H11zM11 11H21V13H11z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M5,3h14c1.1,0,2,0.9,2,2v4h-2V5H5v14h4v2H5c-1.1,0-2-0.9-2-2V5C3,3.9,3.9,3,5,3z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudDirectLink_1DedicatedHosting.propTypes = iconPropTypes;
}
const IbmCloudDirectLink_1Exchange = /*#__PURE__*/React.forwardRef(function IbmCloudDirectLink_1Exchange(_ref60, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref60;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M27,29H13c-1.1,0-2-0.9-2-2v-4h2v4h14V13h-4v-2h4c1.1,0,2,0.9,2,2v14C29,28.1,28.1,29,27,29z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M19 15L19 19 15 19 15 21 21 21 21 15zM17 11L11 11 11 17 13 17 13 13 17 13z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M5,3h14c1.1,0,2,0.9,2,2v4h-2V5H5v14h4v2H5c-1.1,0-2-0.9-2-2V5C3,3.9,3.9,3,5,3z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudDirectLink_1Exchange.propTypes = iconPropTypes;
}
const IbmCloudDirectLink_2Connect = /*#__PURE__*/React.forwardRef(function IbmCloudDirectLink_2Connect(_ref61, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref61;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2,13c0.4,1.2,1.5,2,2.8,2c1.7,0,3-1.3,3-3s-1.3-3-3-3c-1.3,0-2.4,0.8-2.8,2H5c-1.1,0-2,0.9-2,2v6H0v2h3v6 c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2v-4h-2v4H5V13H17.2z M20,11c0.6,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1S19.4,11,20,11z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M29,11V5c0-1.1-0.9-2-2-2H13c-1.1,0-2,0.9-2,2v4h2V5h14v14H14.8c-0.4-1.2-1.5-2-2.8-2c-1.7,0-3,1.3-3,3s1.3,3,3,3 c1.3,0,2.4-0.8,2.8-2H27c1.1,0,2-0.9,2-2v-6h3v-2H29z M12,21c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S12.6,21,12,21z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudDirectLink_2Connect.propTypes = iconPropTypes;
}
const IbmCloudDirectLink_2Dedicated = /*#__PURE__*/React.forwardRef(function IbmCloudDirectLink_2Dedicated(_ref62, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref62;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M32,11h-3V5c0-1.1-0.9-2-2-2H13c-1.1,0-2,0.9-2,2v4h2V5h14v14H13v-4h-2v4c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2v-6h3V11z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M21,17v-4c0-1.1-0.9-2-2-2H5c-1.1,0-2,0.9-2,2v6H0v2h3v6c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2v-4h-2v4H5V13h14v4H21z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudDirectLink_2Dedicated.propTypes = iconPropTypes;
}
const IbmCloudDirectLink_2DedicatedHosting = /*#__PURE__*/React.forwardRef(function IbmCloudDirectLink_2DedicatedHosting(_ref63, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref63;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M19,27H5V13h4v-2H5c-1.1,0-2,0.9-2,2v6H0v2h3v6c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2v-4h-2V27z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M11 19H21V21H11zM11 15H21V17H11zM11 11H21V13H11z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M29,11V5c0-1.1-0.9-2-2-2H13c-1.1,0-2,0.9-2,2v4h2V5h14v14h-4v2h4c1.1,0,2-0.9,2-2v-6h3v-2H29z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudDirectLink_2DedicatedHosting.propTypes = iconPropTypes;
}
const IbmCloudEventNotification = /*#__PURE__*/React.forwardRef(function IbmCloudEventNotification(_ref64, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref64;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M26,19c-0.7,0-1.4,0.3-1.9,0.7l-4.3-2.6c0.1-0.4,0.2-0.7,0.2-1.1c0-0.4-0.1-0.8-0.2-1.1l4.3-2.6c0.5,0.4,1.2,0.7,1.9,0.7 c1.7,0,3-1.3,3-3s-1.3-3-3-3s-3,1.3-3,3c0,0.2,0,0.4,0.1,0.6l-4.3,2.6C18.1,12.4,17.1,12,16,12c-0.6,0-1.1,0.1-1.6,0.4l-3.8-4.8 C10.8,7.1,11,6.6,11,6c0-1.7-1.3-3-3-3S5,4.3,5,6s1.3,3,3,3c0.3,0,0.7-0.1,1-0.2l3.8,4.8c-0.3,0.4-0.5,0.9-0.7,1.4H7.8 c-0.4-1.2-1.5-2-2.8-2c-1.7,0-3,1.3-3,3s1.3,3,3,3c1.3,0,2.4-0.8,2.8-2h4.3c0.1,0.5,0.4,1,0.7,1.4L9,23.2C8.7,23.1,8.3,23,8,23 c-1.7,0-3,1.3-3,3s1.3,3,3,3s3-1.3,3-3c0-0.6-0.2-1.1-0.5-1.6l3.8-4.8c0.5,0.2,1.1,0.4,1.6,0.4c1.1,0,2.1-0.4,2.8-1.2l4.3,2.6 c0,0.2-0.1,0.4-0.1,0.6c0,1.7,1.3,3,3,3s3-1.3,3-3S27.7,19,26,19z M26,9c0.6,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1S25.4,9,26,9z M7,6 c0-0.6,0.4-1,1-1s1,0.4,1,1S8.6,7,8,7S7,6.6,7,6z M5,17c-0.6,0-1-0.4-1-1c0-0.6,0.4-1,1-1c0.6,0,1,0.4,1,1C6,16.6,5.6,17,5,17z M8,27c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S8.6,27,8,27z M16,18c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S17.1,18,16,18z M26,23 c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S26.6,23,26,23z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudEventNotification.propTypes = iconPropTypes;
}
const IbmCloudEventStreams = /*#__PURE__*/React.forwardRef(function IbmCloudEventStreams(_ref65, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref65;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5,9.2l-1,1.7c2.2,1.2,3.5,3.6,3.5,6.1c0,5.2-3.8,8.7-6,10.2V24h-1c-2.5,0-4.9-1.4-6.1-3.6l-1.7,1c1.4,2.6,4,4.2,6.9,4.6 V29c0,0.3,0.2,0.7,0.5,0.9C18.6,30,18.8,30,19,30c0.2,0,0.3,0,0.4-0.1C19.8,29.7,28,25.5,28,17C28,13.8,26.3,10.8,23.5,9.2z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M20,13.1V7.8c1.2-0.4,2-1.5,2-2.8c0-1.7-1.3-3-3-3s-3,1.3-3,3c0,1.3,0.8,2.4,2,2.8v5.3c-0.4,0.1-0.7,0.2-1,0.4l-5.3-5.3 C11.9,7.9,12,7.5,12,7c0-1.7-1.3-3-3-3S6,5.3,6,7s1.3,3,3,3c0.5,0,0.9-0.1,1.3-0.3l5.3,5.3c-0.2,0.3-0.3,0.7-0.4,1H9.8 c-0.4-1.2-1.5-2-2.8-2c-1.7,0-3,1.3-3,3s1.3,3,3,3c1.3,0,2.4-0.8,2.8-2h5.3c0.4,1.7,2,3,3.9,3c2.2,0,4-1.8,4-4 C23,15.1,21.7,13.6,20,13.1z M19,4c0.6,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1S18.4,4,19,4z M9,8C8.4,8,8,7.6,8,7s0.4-1,1-1s1,0.4,1,1 S9.6,8,9,8z M7,18c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S7.6,18,7,18z M19,19c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S20.1,19,19,19z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudEventStreams.propTypes = iconPropTypes;
}
const IbmCloudForEducation = /*#__PURE__*/React.forwardRef(function IbmCloudForEducation(_ref66, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref66;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M30 30h-2c0-1.6542-1.3457-3-3-3h-4c-1.6543 0-3 1.3458-3 3h-2c0-2.757 2.2429-5 5-5h4c2.7571 0 5 2.243 5 5zM15 16c-.5522 0-1 .4478-1 1v6h2v-6c0-.5522-.4478-1-1-1z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M32,12H14v2h4v5c0,2.7568,2.2429,5,5,5s5-2.2432,5-5v-5h4v-2Zm-9,10c-1.6543,0-3-1.3457-3-3v-1h6v1c0,1.6543-1.3457,3-3,3Zm3-6h-6v-2h6v2Z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7983,10c-.9292-4.5586-4.9692-8-9.7983-8-4.8479,0-8.9382,3.4399-9.822,8.124-3.5232,.6294-6.178,3.7251-6.178,7.376,0,4.1357,3.3645,7.5,7.5,7.5h4.5v-2H7.5c-3.0327,0-5.5-2.4673-5.5-5.5,0-2.8779,2.2502-5.2852,5.1228-5.48l.8364-.0566,.0901-.8335c.4395-4.0645,3.8574-7.1299,7.9507-7.1299,3.7195,0,6.845,2.5552,7.7368,6h2.0615Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudForEducation.propTypes = iconPropTypes;
}
const IbmCloudHpc = /*#__PURE__*/React.forwardRef(function IbmCloudHpc(_ref67, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref67;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M22 13H24V15H22zM26 13H28V15H26zM30 13H32V15H30zM30 17H32V19H30zM15 20H17V22H15zM20 28H22V30H20zM24 28H26V30H24zM19 26h9v-9h-9v9zm2-7h5v5h-5v-5z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "m16,3v.0005c-.002,0-.004-.0003-.006-.0003-4.7007.0032-8.9033,3.3306-9.8242,8.1152C2.6037,11.7607.0078,14.8598,0,18.4815c-.0089,4.1434,3.345,7.5096,7.4911,7.5185h9.5089v-2H7.4954c-3.0367-.0065-5.502-2.4802-5.4954-5.5142.0057-2.6569,1.9092-4.9289,4.5259-5.4023l1.3488-.2441.2591-1.3459c.7241-3.7623,4.0386-6.4933,7.8662-6.4935h0c3.7363,0,6.9395,2.5367,7.79,6.169l1.9473-.4561c-1.0635-4.541-5.0674-7.7129-9.7373-7.7129Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudHpc.propTypes = iconPropTypes;
}
const IbmCloudHsm = /*#__PURE__*/React.forwardRef(function IbmCloudHsm(_ref68, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref68;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M28,21.142V10h-5v2h3v2h-3v2h3v5.142c-1.7203,.4471-3,1.9993-3,3.858,0,2.2061,1.7944,4,4,4s4-1.7939,4-4c0-1.8587-1.2797-3.4108-3-3.858Zm-1,5.858c-1.103,0-2-.8975-2-2s.897-2,2-2,2,.8975,2,2-.897,2-2,2Z"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "24",
    r: "1"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "8",
    r: "1"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M26,6v2h2v-2c0-1.1046-.8954-2-2-2H6c-1.1046,0-2,.8954-2,2v4c0,1.1046,.8954,2,2,2h4v8H6c-1.1045,0-2,.8955-2,2v4c0,1.1045,.8955,2,2,2h14v-2H6v-4h14v-2H12V12h8v-2H6V6H26Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudHsm.propTypes = iconPropTypes;
}
const IbmCloudHyperProtectCryptoServices = /*#__PURE__*/React.forwardRef(function IbmCloudHyperProtectCryptoServices(_ref69, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref69;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M25,30l-2.1-1c-1.7-0.8-2.9-2.6-2.9-4.5V18h10v6.5c0,1.9-1.1,3.7-2.9,4.5L25,30z M22,20v4.5c0,1.2,0.7,2.2,1.7,2.7l1.3,0.6 l1.3-0.6c1-0.5,1.7-1.6,1.7-2.7V20H22z"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "10",
    r: "2"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M21,2c-5,0-9,4-9,9c0,0.9,0.1,1.8,0.4,2.6L2,24v6h6l10-10l-1.4-1.4l-2.8,2.8L12.4,20L11,21.4l1.4,1.4l-1.6,1.6L9.4,23 L8,24.4l1.4,1.4L7.2,28H4v-3.2l9.8-9.8l0.8-0.8L14.3,13c-0.2-0.7-0.3-1.3-0.3-2c0-3.9,3.1-7,7-7s7,3.1,7,7c0,1.5-0.5,2.9-1.3,4h2.3 c0.6-1.2,0.9-2.6,0.9-4C30,6,26,2,21,2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudHyperProtectCryptoServices.propTypes = iconPropTypes;
}
const IbmCloudHyperProtectDbaas = /*#__PURE__*/React.forwardRef(function IbmCloudHyperProtectDbaas(_ref70, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref70;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M24,30l-2.1-1c-1.7-0.8-2.9-2.6-2.9-4.5V18h10v6.5c0,1.9-1.1,3.7-2.9,4.5L24,30z M21,20v4.5c0,1.2,0.7,2.2,1.7,2.7l1.3,0.6 l1.3-0.6c1-0.5,1.7-1.6,1.7-2.7V20H21z"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "23",
    r: "1"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "15",
    r: "1"
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "7",
    r: "1"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M23,2H7C5.9,2,5,2.9,5,4v22c0,1.1,0.9,2,2,2h9v-2H7v-6h9v-2H7v-6h16v3h2V4C25,2.9,24.1,2,23,2z M7,10V4h16v6H7z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudHyperProtectDbaas.propTypes = iconPropTypes;
}
const IbmCloudHyperProtectVs = /*#__PURE__*/React.forwardRef(function IbmCloudHyperProtectVs(_ref71, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref71;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M20,18v6.5c0,1.9,1.1,3.7,2.9,4.5l2.1,1l2.1-1c1.7-0.8,2.9-2.6,2.9-4.5V18H20z M28,24.5c0,1.2-0.7,2.2-1.7,2.7L25,27.8 l-1.3-0.6c-1-0.5-1.7-1.6-1.7-2.7V20h6V24.5z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M25,2H5C3.9,2,3,2.9,3,4v22c0,1.1,0.9,2,2,2h11V4h9v11h2V4C27,2.9,26.1,2,25,2z M13.6,12.2L5,23.9V5.1L13.6,12.2z M6,26 l8-10.9V26H6z M14,9.9L6.8,4H14V9.9z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudHyperProtectVs.propTypes = iconPropTypes;
}
const IbmCloudInternetServices = /*#__PURE__*/React.forwardRef(function IbmCloudInternetServices(_ref72, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref72;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M27,22c-0.7,0-1.4,0.3-1.9,0.7l-5.2-3.1c0-0.2,0.1-0.4,0.1-0.6s0-0.4-0.1-0.6l5.2-3.1c0.5,0.4,1.2,0.7,1.9,0.7 c1.7,0,3-1.3,3-3s-1.3-3-3-3s-3,1.3-3,3c0,0.2,0,0.4,0.1,0.6l-5.2,3.1C18.4,16.3,17.7,16,17,16c-1.7,0-3,1.3-3,3s1.3,3,3,3 c0.7,0,1.4-0.3,1.9-0.7l5.2,3.1c0,0.2-0.1,0.4-0.1,0.6c0,1.7,1.3,3,3,3s3-1.3,3-3S28.7,22,27,22z M27,12c0.6,0,1,0.4,1,1s-0.4,1-1,1 s-1-0.4-1-1S26.4,12,27,12z M17,20c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S17.6,20,17,20z M27,26c-0.6,0-1-0.4-1-1s0.4-1,1-1 s1,0.4,1,1S27.6,26,27,26z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M19,25H8.5c-3,0-5.5-2.5-5.5-5.5c0-2.7,1.9-4.9,4.5-5.4l1.3-0.2l0.3-1.3C9.9,8.7,13.2,6,17,6c0.5,0,1,0,1.5,0.1 c1.6,0.3,3,1.1,4.2,2.2l1.4-1.4c-1.4-1.4-3.2-2.4-5.2-2.7C18.3,4.1,17.6,4,17,4c-4.7,0-8.9,3.3-9.8,8.1C3.6,12.8,1,15.9,1,19.5 C1,23.6,4.3,27,8.5,27H19V25z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudInternetServices.propTypes = iconPropTypes;
}
const IbmCloudIpsecVpn = /*#__PURE__*/React.forwardRef(function IbmCloudIpsecVpn(_ref73, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref73;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M16 29c-.373 0-.7151-.2076-.8872-.5386l-2.0801-4 1.7744-.9229 1.1929 2.2939 4.3127-8.2938 1.7744.9226-5.2 10c-.1721.3311-.5142.5387-.8872.5387zM11 15.2783v-2.2783c0-2.2056-1.7944-4-4-4s-4 1.7944-4 4v2.2783c-.595.3467-1 .9849-1 1.7217v5c0 1.1025.897 2 2 2h6c1.103 0 2-.8975 2-2v-5c0-.7368-.405-1.375-1-1.7217zm-4-4.2783c1.103 0 2 .8975 2 2v2H5v-2c0-1.1025.897-2 2-2zm3 11H4v-5h6v5zM29 2h-9.2773c-.3464-.5952-.9841-1-1.7227-1-1.1045 0-2 .8955-2 2s.8955 2 2 2c.7385 0 1.3762-.4048 1.7227-1h7.6304l-4.1697 8.0186c-.0613-.0059-.1206-.0186-.1833-.0186-1.1045 0-2 .8955-2 2s.8955 2 2 2 2-.8955 2-2c0-.2881-.0635-.5601-.1729-.8076L29.8872 3.4614c.02-.0439.1128-.2104.1128-.4614 0-.5522-.4478-1-1-1zM3 2c-.5522 0-1 .4478-1 1 0 .2509.0929.4177.1128.4614l1.8401 3.5386h2.2542l-1.5601-3H14V2H3z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudIpsecVpn.propTypes = iconPropTypes;
}
const IbmCloudKeyProtect = /*#__PURE__*/React.forwardRef(function IbmCloudKeyProtect(_ref74, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref74;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M26,14.1V2h-5v2h3v2h-3v2h3v6.1c-1.7,0.4-3,2-3,3.9c0,2.2,1.8,4,4,4s4-1.8,4-4C29,16.1,27.7,14.6,26,14.1z M25,20 c-1.1,0-2-0.9-2-2c0-1.1,0.9-2,2-2s2,0.9,2,2C27,19.1,26.1,20,25,20z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M15,31l-5.5-3.2c-3.4-2-5.5-5.6-5.5-9.5V4c0-1.1,0.9-2,2-2h12v2H6v14.3c0,3.2,1.7,6.2,4.5,7.8l4.5,2.7l4.5-2.7 c1.1-0.7,2.1-1.5,2.8-2.6l1.6,1.1c-0.9,1.3-2.1,2.4-3.5,3.2L15,31z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudKeyProtect.propTypes = iconPropTypes;
}
const IbmCloudKubernetesService = /*#__PURE__*/React.forwardRef(function IbmCloudKubernetesService(_ref75, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref75;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M16,23c-0.2,0-0.4,0-0.5-0.1l-5-3C10.2,19.7,10,19.4,10,19v-6c0-0.4,0.2-0.7,0.5-0.9l5-3C15.6,9,15.8,9,16,9 c0.2,0,0.4,0,0.5,0.1l5,3c0.3,0.2,0.5,0.5,0.5,0.9v6c0,0.4-0.2,0.7-0.5,0.9l-5,3C16.4,23,16.2,23,16,23z M12,18.4l4,2.4l4-2.4v-4.9 l-4-2.4l-4,2.4V18.4z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M16,31c-0.2,0-0.3,0-0.5-0.1l-12-7C3.2,23.7,3,23.4,3,23V9c0-0.4,0.2-0.7,0.5-0.9l12-7C15.7,1,15.8,1,16,1 c0.2,0,0.3,0,0.5,0.1l12,7l-1,1.7L16,3.2L5,9.6v12.9l11,6.4l11-6.4V15h2v8c0,0.4-0.2,0.7-0.5,0.9l-12,7C16.3,31,16.2,31,16,31z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudKubernetesService.propTypes = iconPropTypes;
}
const IbmCloudLogging = /*#__PURE__*/React.forwardRef(function IbmCloudLogging(_ref76, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref76;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4,10c0.3,0.5,0.7,0.9,1.3,1.2l1.3,0.6l1.3-0.6c1-0.5,1.7-1.6,1.7-2.7V4h-3V2h5v6.5c0,1.9-1.1,3.7-2.9,4.5l-2.2,1l-2.1-1 c-1.3-0.6-2.2-1.7-2.6-3H24.4z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M16 6H24V8H16zM16 2H24V4H16z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M28,16v6H4V6h10V4H4C2.9,4,2,4.9,2,6v16c0,1.1,0.9,2,2,2h8v4H8v2h16v-2h-4v-4h8c1.1,0,2-0.9,2-2v-6H28z M18,28h-4v-4h4V28z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudLogging.propTypes = iconPropTypes;
}
const IbmCloudMassDataMigration = /*#__PURE__*/React.forwardRef(function IbmCloudMassDataMigration(_ref77, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref77;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M22 30H10c-1.1 0-2-.9-2-2v-3h2v3h12v-3h2v3C24 29.1 23.1 30 22 30zM15 14.8L15 25 17 25 17 14.8 19.6 17.4 21 16 16 11 11 16 12.4 17.4z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8,9.1C23.9,5,20.3,2,16,2S8.1,5,7.2,9.1C4.2,9.7,2,12.4,2,15.5C2,19.1,4.9,22,8.5,22H12v-2H8.5C6,20,4,18,4,15.5 c0-2.3,1.8-4.3,4.1-4.5L9,11l0.1-0.8C9.5,6.6,12.5,4,16,4c3.5,0,6.5,2.6,6.9,6.1L23,11l0.8,0.1c2.3,0.2,4.1,2.2,4.1,4.5 c0,2.5-2,4.5-4.5,4.5H20v2h3.5c3.6,0,6.5-2.9,6.5-6.5C30,12.4,27.8,9.7,24.8,9.1z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudMassDataMigration.propTypes = iconPropTypes;
}
const IbmCloudPal = /*#__PURE__*/React.forwardRef(function IbmCloudPal(_ref78, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref78;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5,17.7l-6-3.5C24.4,14,24.2,14,24,14s-0.4,0-0.5,0.1l-6,3.5c-0.3,0.2-0.5,0.5-0.5,0.9v6.9c0,0.4,0.2,0.7,0.5,0.9l6,3.5 C23.6,30,23.8,30,24,30s0.4,0,0.5-0.1l6-3.5c0.3-0.2,0.5-0.5,0.5-0.9v-6.9C31,18.2,30.8,17.9,30.5,17.7z M29,24.9l-5,3l-5-3v-5.8 l5-3l5,3V24.9z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M14,26H9c-4.4,0-8-3.6-8-8c0-3.7,2.6-6.9,6.2-7.8C8,5.5,12.1,2,17,2c5.5,0,10,4.5,10,10h-2c0-4.4-3.6-8-8-8 c-4.1,0-7.5,3.1-8,7.2L9,12l-0.8,0.1C5.2,12.5,3,15,3,18c0,3.3,2.7,6,6,6h5V26z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudPal.propTypes = iconPropTypes;
}
const IbmCloudPrivilegedAccessGateway = /*#__PURE__*/React.forwardRef(function IbmCloudPrivilegedAccessGateway(_ref79, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref79;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M32 23L27 28 25.6 26.6 28.2 24 20 24 20 22 28.2 22 25.6 19.4 27 18z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5,2.7C25.1,2.3,24.6,2,24,2h-2.7c-0.6,0-1.1,0.3-1.3,0.8L19.4,4H18V3.5C18,2.7,17.3,2,16.5,2h-5C10.7,2,10,2.7,10,3.5V4 H8.6L8,2.8C7.8,2.3,7.3,2,6.7,2H4C3.4,2,2.9,2.3,2.5,2.7C2.1,3.2,1.9,3.8,2,4.4l0.7,4.1C3,9.9,4.2,11,5.7,11H6v12c-1.7,0-3,1.3-3,3 v4h19v-2h-5v-7c0-1.7-1.3-3-3-3s-3,1.3-3,3v7H5v-2c0-0.6,0.4-1,1-1h2V11h12v7h2v-7h0.3c1.5,0,2.7-1.1,3-2.5L26,4.4 C26.1,3.8,25.9,3.2,25.5,2.7z M13,21c0-0.6,0.4-1,1-1s1,0.4,1,1v7h-2V21z M23.3,8.2c-0.1,0.5-0.5,0.8-1,0.8H5.7 c-0.5,0-0.9-0.4-1-0.8L4,4h2.4l1,2H12V4h4v2h4.6l1-2L24,4L23.3,8.2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudPrivilegedAccessGateway.propTypes = iconPropTypes;
}
const IbmCloudProjects = /*#__PURE__*/React.forwardRef(function IbmCloudProjects(_ref80, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref80;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M30 18h-10v6.4678c0 1.9229 1.1231 3.6973 2.8613 4.5195l2.1387 1.0127 2.1387-1.0127c1.7383-.8223 2.8613-2.5967 2.8613-4.5195v-6.4678h0zm-5 9.7861l-1.2832-.6074c-1.043-.4932-1.7168-1.5576-1.7168-2.7109v-4.4678h6v4.4678c0 1.1533-.6738 2.2178-1.7168 2.7109l-1.2832.6074h0zM17 18H5c-1.1045 0-2 .8954-2 2v5c0 1.1045.8955 2 2 2h12v-2H5v-5h12v-2h0zM27 4h-5c-1.1045 0-2 .8954-2 2v9h2V6h5v9h2V6c0-1.1046-.8955-2-2-2h0zM15 4H5c-1.1045 0-2 .8954-2 2v7c0 1.1045.8955 2 2 2h10c1.1045 0 2-.8955 2-2v-7c0-1.1046-.8955-2-2-2h0zM5 13v-7h10v7H5z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudProjects.propTypes = iconPropTypes;
}
const IbmCloudResiliency = /*#__PURE__*/React.forwardRef(function IbmCloudResiliency(_ref81, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref81;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M24 24v6h6v-6h-6zm4 4h-2v-2h2v2zM2 30h6v-6H2v6zm2-4h2v2h-2v-2z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M26 15h-9v-6.1631c1.4407-.4336 2.5-1.7571 2.5-3.3369 0-1.9297-1.5703-3.5-3.5-3.5s-3.5 1.5703-3.5 3.5c0 1.5798 1.0593 2.9033 2.5 3.3369v6.1631H6c-1.1025 0-2 .8972-2 2v5h2v-5h9v7h-2v6h6v-6h-2v-7h9v5h2v-5c0-1.1028-.8975-2-2-2zM14.5 5.5c0-.8271.6729-1.5 1.5-1.5s1.5.6729 1.5 1.5-.6729 1.5-1.5 1.5-1.5-.6729-1.5-1.5zm2.5 22.5h-2v-2h2v2zM26.5 9c1.9297 0 3.5-1.5703 3.5-3.5s-1.5703-3.5-3.5-3.5-3.5 1.5703-3.5 3.5 1.5703 3.5 3.5 3.5zm0-5c.8271 0 1.5.6729 1.5 1.5s-.6729 1.5-1.5 1.5-1.5-.6729-1.5-1.5.6729-1.5 1.5-1.5zM5.5 9c1.9297 0 3.5-1.5703 3.5-3.5s-1.5703-3.5-3.5-3.5-3.5 1.5703-3.5 3.5 1.5703 3.5 3.5 3.5zm0-5c.8271 0 1.5.6729 1.5 1.5s-.6729 1.5-1.5 1.5-1.5-.6729-1.5-1.5.6729-1.5 1.5-1.5z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudResiliency.propTypes = iconPropTypes;
}
const IbmCloudSecretsManager = /*#__PURE__*/React.forwardRef(function IbmCloudSecretsManager(_ref82, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref82;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M20,16c0-0.7-0.2-1.4-0.6-2l3.3-3.3l-1.4-1.4L18,12.6c-0.6-0.4-1.3-0.6-2-0.6c-0.7,0-1.4,0.2-2,0.6l-3.3-3.3l-1.4,1.4 l3.3,3.3c-0.4,0.6-0.6,1.3-0.6,2c0,0.7,0.2,1.4,0.6,2l-3.3,3.3l1.4,1.4l3.3-3.3c0.6,0.4,1.3,0.6,2,0.6c0.7,0,1.4-0.2,2-0.6l3.3,3.3 l1.4-1.4L19.4,18C19.8,17.4,20,16.7,20,16z M16,18c-1.1,0-2-0.9-2-2c0-1.1,0.9-2,2-2c1.1,0,2,0.9,2,2C18,17.1,17.1,18,16,18z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M26,17h6v-2h-2.1C29.4,7.7,23.4,2,16,2C8.3,2,2,8.3,2,16s6.3,14,14,14c5.2,0,9.7-2.8,12.1-7l-1.7-1c-2.1,3.6-5.9,6-10.4,6 C9.4,28,4,22.6,4,16C4,9.4,9.4,4,16,4c6.3,0,11.4,4.9,11.9,11H26V17z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudSecretsManager.propTypes = iconPropTypes;
}
const IbmCloudSecurityComplianceCenter = /*#__PURE__*/React.forwardRef(function IbmCloudSecurityComplianceCenter(_ref83, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref83;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M30,18v5.5c0,1.5-0.9,2.8-2.3,3.5L26,27.8 L24.3,27c-1.4-0.6-2.3-2-2.3-3.5V18H30 M32,16H20v7.5c0,2.2,1.3,4.3,3.4,5.3L26,30l2.6-1.2c2.1-1,3.4-3,3.4-5.3V16L32,16z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M16,25H7.5C3.4,25,0,21.6,0,17.5c0-3.7,2.7-6.7,6.2-7.4C7.1,5.4,11.2,2,16,2c5.5,0,10,4.5,10,10h-2c0-4.4-3.6-8-8-8 c-4.1,0-7.5,3.1-8,7.1L8,12L7.1,12C4.2,12.2,2,14.6,2,17.5c0,3,2.5,5.5,5.5,5.5H16V25z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudSecurityComplianceCenter.propTypes = iconPropTypes;
}
const IbmCloudSecurityComplianceCenterWorkloadProtection = /*#__PURE__*/React.forwardRef(function IbmCloudSecurityComplianceCenterWorkloadProtection(_ref84, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref84;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M20 18v6.5c0 1.9 1.1 3.7 2.9 4.5l2.1 1 2.1-1c1.7-.8 2.9-2.6 2.9-4.5V18H20zM28 24.5c0 1.2-.7 2.2-1.7 2.7L25 27.8l-1.3-.6c-1-.5-1.7-1.6-1.7-2.7V20h6V24.5zM16 20c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4h-2c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2V20z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M16,25c-5,0-9-4-9-9s4-9,9-9s9,4,9,9h-2c0-3.9-3.1-7-7-7s-7,3.1-7,7s3.1,7,7,7V25z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30C8.3,30,2,23.7,2,16S8.3,2,16,2s14,6.3,14,14h-2c0-6.6-5.4-12-12-12S4,9.4,4,16s5.4,12,12,12V30z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudSecurityComplianceCenterWorkloadProtection.propTypes = iconPropTypes;
}
const IbmCloudSubnets = /*#__PURE__*/React.forwardRef(function IbmCloudSubnets(_ref85, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref85;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M26,22a3.6069,3.6069,0,0,0-2,.6L19.4143,18,18,19.4141,22.6,24a4.1755,4.1755,0,0,0-.4,1H9.8583A3.5525,3.5525,0,0,0,9.4,24L24,9.4a3.6069,3.6069,0,0,0,2,.6,4,4,0,1,0-3.8569-5H9.9A4.0785,4.0785,0,0,0,6,2a4,4,0,0,0,0,8,3.6066,3.6066,0,0,0,2-.6L12.5858,14,14,12.5859,9.4,8a4.175,4.175,0,0,0,.4-1H22.1418A3.5553,3.5553,0,0,0,22.6,8L8,22.6A3.6066,3.6066,0,0,0,6,22a4,4,0,1,0,3.8569,5H22.1A4.0118,4.0118,0,1,0,26,22ZM26,4a2,2,0,1,1-2,2A2.0058,2.0058,0,0,1,26,4ZM6,8A2,2,0,1,1,8,6,2.0058,2.0058,0,0,1,6,8ZM6,28a2,2,0,1,1,2-2A2.0058,2.0058,0,0,1,6,28Zm20,0a2,2,0,1,1,2-2A2.0058,2.0058,0,0,1,26,28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudSubnets.propTypes = iconPropTypes;
}
const IbmCloudSysdigSecure = /*#__PURE__*/React.forwardRef(function IbmCloudSysdigSecure(_ref86, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref86;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M25,14l-2.1-1c-1.7-0.8-2.9-2.6-2.9-4.5V2h10v6.5c0,1.9-1.1,3.7-2.9,4.5L25,14z M22,4v4.5c0,1.2,0.7,2.2,1.7,2.7l1.3,0.6 l1.3-0.6c1-0.5,1.7-1.6,1.7-2.7V4H22z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M28,16v6H4V6h12V4H4C2.9,4,2,4.9,2,6v16c0,1.1,0.9,2,2,2h8v4H8v2h16v-2h-4v-4h8c1.1,0,2-0.9,2-2v-6H28z M18,28h-4v-4h4V28z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudSysdigSecure.propTypes = iconPropTypes;
}
const IbmCloudTransitGateway = /*#__PURE__*/React.forwardRef(function IbmCloudTransitGateway(_ref87, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref87;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9,20.9l3.5-3.5a1.9333,1.9333,0,0,0,0-2.8L24.1,9.3l1.4-1.4A.9015.9015,0,0,0,26,8a2,2,0,1,0-2-2,.9015.9015,0,0,0,.1.5L18,12.6a3.6333,3.6333,0,0,0-4,0L10.7,9.3,16,4l3.5,3.5,1.4-1.4L17.4,2.6a1.9333,1.9333,0,0,0-2.8,0L9.3,7.9,7.9,6.5A.9015.9015,0,0,0,8,6,2,2,0,1,0,6,8a.9015.9015,0,0,0,.5-.1L12.6,14a3.6333,3.6333,0,0,0,0,4L9.3,21.3,4,16l3.5-3.5L6.1,11.1,2.6,14.6a1.9333,1.9333,0,0,0,0,2.8l5.3,5.3L6.5,24.1A.9015.9015,0,0,0,6,24a2,2,0,1,0,2,2,.9015.9015,0,0,0-.1-.5L14,19.4a3.6333,3.6333,0,0,0,4,0l3.3,3.3L16,28l-3.5-3.5-1.4,1.4,3.5,3.5a1.9333,1.9333,0,0,0,2.8,0l5.3-5.3,1.4,1.4c0,.2-.1.3-.1.5a2,2,0,1,0,2-2,.9015.9015,0,0,0-.5.1L19.4,18a3.6333,3.6333,0,0,0,0-4l3.3-3.3L28,16l-3.5,3.5ZM16,18a2,2,0,1,1,2-2A2.0059,2.0059,0,0,1,16,18Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudTransitGateway.propTypes = iconPropTypes;
}
const IbmCloudVirtualServerClassic = /*#__PURE__*/React.forwardRef(function IbmCloudVirtualServerClassic(_ref88, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref88;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "26",
    r: "1"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "m26,22h-5v2h5v4H6v-4h9c1.1,0,2-.9,2-2h0v-9.17l2.59,2.59,1.41-1.42-5-5-5,5,1.41,1.41,2.59-2.58v9.17H6c-1.1,0-2,.9-2,2v4c0,1.1.9,2,2,2h20c1.1,0,2-.9,2-2v-4c0-1.1-.9-2-2-2Z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "m23.75,8.05c-.88-3.5-4.08-6.05-7.75-6.05s-6.87,2.55-7.75,6.05c-2.96.37-5.25,2.9-5.25,5.95,0,3.31,2.69,6,6,6h2v-2h-2c-2.21,0-4-1.79-4-4,0-2.19,1.77-3.97,3.95-4l.99.02.12-.88c.43-2.93,2.98-5.14,5.94-5.14s5.51,2.21,5.93,5.15l.12.88.88-.02.13-.01c2.18.03,3.94,1.81,3.94,4,0,2.21-1.79,4-4,4h-2v2h2c3.31,0,6-2.69,6-6,0-3.05-2.29-5.58-5.25-5.95Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudVirtualServerClassic.propTypes = iconPropTypes;
}
const IbmCloudVirtualServerVpc = /*#__PURE__*/React.forwardRef(function IbmCloudVirtualServerVpc(_ref89, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref89;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: "8",
    cy: "26",
    r: "1"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M5 30h22c1.1 0 2-.9 2-2v-4c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2zm0-6h22v4H5v-4zM23 20h-14c-3.31 0-6-2.69-6-6 0-3.05 2.29-5.58 5.25-5.95.88-3.5 4.08-6.05 7.75-6.05s6.87 2.55 7.75 6.05c2.96.37 5.25 2.9 5.25 5.95 0 3.31-2.69 6-6 6zm-14.05-10c-2.18.03-3.95 1.81-3.95 4 0 2.21 1.79 4 4 4h14c2.21 0 4-1.79 4-4 0-2.19-1.76-3.97-3.94-4l-.12.01-.88.02-.12-.88c-.43-2.94-2.98-5.15-5.94-5.15s-5.51 2.21-5.93 5.15l-.12.88-1-.03z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudVirtualServerVpc.propTypes = iconPropTypes;
}
const IbmCloudVpc = /*#__PURE__*/React.forwardRef(function IbmCloudVpc(_ref90, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref90;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "m23.4141,22l-13.4141-13.4141V2H2v8h6.5859l13.4141,13.4141v6.5859h8v-8h-6.5859ZM8,8h-4V4h4v4Zm20,20h-4v-4h4v4Z"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M30 6c0-2.2056-1.7944-4-4-4-1.8584 0-3.4106 1.2798-3.8579 3h-9.1421v2h9.1421c.3638 1.3989 1.4592 2.4941 2.8579 2.8579v9.1421h2v-9.1421c1.7202-.4473 3-1.9995 3-3.8579zm-4 2c-1.103 0-2-.8975-2-2s.897-2 2-2 2 .8975 2 2-.897 2-2 2zM19 25h-9.1421c-.3638-1.3989-1.4592-2.4941-2.8579-2.8579v-9.1421h-2v9.1421c-1.7202.4473-3 1.9995-3 3.8579 0 2.2056 1.7944 4 4 4 1.8584 0 3.4106-1.2798 3.8579-3h9.1421v-2zm-13 3c-1.103 0-2-.8975-2-2s.897-2 2-2 2 .8975 2 2-.897 2-2 2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudVpc.propTypes = iconPropTypes;
}
const IbmCloudVpcEndpoints = /*#__PURE__*/React.forwardRef(function IbmCloudVpcEndpoints(_ref91, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref91;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M20,27H7a2.0059,2.0059,0,0,1-2-2V12H7V25H20Z"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4,22l-4-4a3.6057,3.6057,0,0,0,.6-2,4.0118,4.0118,0,0,0-4-4,3.6057,3.6057,0,0,0-2,.6l-4-4V2H2v8H8.6l4,4a3.6057,3.6057,0,0,0-.6,2,4.0118,4.0118,0,0,0,4,4,3.6057,3.6057,0,0,0,2-.6l4,4V30h8V22ZM8,8H4V4H8Zm8,10a2,2,0,1,1,2-2A2.0059,2.0059,0,0,1,16,18ZM28,28H24V24h4Z"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M25,20h2V7a2.0059,2.0059,0,0,0-2-2H12V7H25Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudVpcEndpoints.propTypes = iconPropTypes;
}
const IbmCloudPakApplications = /*#__PURE__*/React.forwardRef(function IbmCloudPakApplications(_ref92, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref92;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M21,22H15a2.0023,2.0023,0,0,1-2-2V16a2.0023,2.0023,0,0,1,2-2h6a2.0023,2.0023,0,0,1,2,2v4A2.0023,2.0023,0,0,1,21,22Zm-6-6v4h6V16Z"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M11,17H9V12a2.0023,2.0023,0,0,1,2-2h6v2H11Z"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudPakApplications.propTypes = iconPropTypes;
}
const IbmCloudPakBusinessAutomation = /*#__PURE__*/React.forwardRef(function IbmCloudPakBusinessAutomation(_ref93, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref93;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M25,16c0-1.5-1.2-2.8-2.7-3c-1.1-2.4-3.5-4-6.3-4c-0.2,0-0.5,0-0.7,0.1C14.7,8.4,13.9,8,13,8c-1.7,0-3,1.3-3,3 c0,0.4,0.1,0.7,0.2,1.1C9.4,13.2,9,14.5,9,16s0.4,2.8,1.2,3.9C10.1,20.3,10,20.6,10,21c0,1.7,1.3,3,3,3c0.9,0,1.7-0.4,2.3-1.1 c0.2,0,0.5,0.1,0.7,0.1c2.8,0,5.2-1.7,6.3-4C23.8,18.8,25,17.5,25,16z M13,10c0.6,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1 S12.4,10,13,10z M13,22c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S13.6,22,13,22z M16,21c0-1.7-1.3-3-3-3c-0.5,0-1,0.1-1.4,0.4 C11.2,17.7,11,16.9,11,16s0.2-1.7,0.6-2.4C12,13.9,12.5,14,13,14c1.7,0,3-1.3,3-3c1.9,0,3.4,1,4.3,2.5C19.5,14.1,19,15,19,16 s0.5,1.9,1.3,2.5C19.4,20,17.9,21,16,21z M22,17c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S22.6,17,22,17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,31c-0.2,0-0.3,0-0.5-0.1l-12-7C3.2,23.7,3,23.4,3,23V9c0-0.4,0.2-0.7,0.5-0.9l12-7c0.3-0.2,0.7-0.2,1,0l12,7l-1,1.7 L16,3.2L5,9.6v12.9l11,6.4l11-6.4V15h2v8c0,0.4-0.2,0.7-0.5,0.9l-12,7C16.3,31,16.2,31,16,31z"
  })))), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudPakBusinessAutomation.propTypes = iconPropTypes;
}
const IbmCloudPakData = /*#__PURE__*/React.forwardRef(function IbmCloudPakData(_ref94, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref94;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "15",
    r: "1"
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: "8",
    cy: "15",
    r: "1"
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: "21",
    cy: "10",
    r: "1"
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: "15",
    cy: "23",
    r: "1"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M21,19a1.9822,1.9822,0,0,0-.5116.0743L18.707,17.293l-.0257.0257A2.9642,2.9642,0,0,0,19,16a3.0033,3.0033,0,0,0-3-3,2.9642,2.9642,0,0,0-1.3187.3187l.0257-.0257-1.7813-1.7814a2.0345,2.0345,0,1,0-1.4141,1.4141L13.293,14.707l.0258-.0258A2.9634,2.9634,0,0,0,13,16a3.0033,3.0033,0,0,0,3,3,2.9634,2.9634,0,0,0,1.3188-.3188l-.0258.0258,1.7813,1.7814A1.9956,1.9956,0,1,0,21,19Zm-5-2a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,16,17Z"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudPakData.propTypes = iconPropTypes;
}
const IbmCloudPakIntegration = /*#__PURE__*/React.forwardRef(function IbmCloudPakIntegration(_ref95, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref95;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1213 9.8787a3 3 0 00-4.2426 0l-.4645.4644 1.4142 1.4142.4645-.4645a1 1 0 011.4142 1.4144L17.4142 16l1.4143 1.4142 3.2928-3.2929A3 3 0 0022.1213 9.8787zM12.7071 20.7072a1 1 0 01-1.4142-1.4144L14.5858 16l-1.4142-1.4142L9.8787 17.8787a3 3 0 104.2426 4.2426l.4645-.4644-1.4142-1.4143zM14.1213 9.8787a3 3 0 00-4.2426 4.2426l.4645.4645 1.4142-1.4142-.4645-.4645a1 1 0 011.4142-1.4143L16 14.5858l1.4142-1.4143z"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1213,17.8787l-.4645-.4645-1.4141,1.4142.4644.4645a1,1,0,0,1-1.4142,1.4143L16,17.4142l-1.4142,1.4142,3.2929,3.2929a3,3,0,0,0,4.2426-4.2426Z"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudPakIntegration.propTypes = iconPropTypes;
}
const IbmCloudPakMantaAutomatedDataLineage = /*#__PURE__*/React.forwardRef(function IbmCloudPakMantaAutomatedDataLineage(_ref96, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref96;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M30,11V5H24V7H14V4a2.0025,2.0025,0,0,0-2-2H4A2.0025,2.0025,0,0,0,2,4v8a2.0025,2.0025,0,0,0,2,2h8a2.0025,2.0025,0,0,0,2-2V9a3.0033,3.0033,0,0,1,3,3v9H11V19H5v6h6V23h6v2a2.0025,2.0025,0,0,0,2,2h5v2h6V23H24v2H19V18h5v2h6V14H24v2H19V12a4.9521,4.9521,0,0,0-1.0254-3H24v2ZM4,12V4h8v8ZM9,23H7V21H9Zm17,2h2v2H26Zm0-9h2v2H26Zm0-9h2V9H26Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudPakMantaAutomatedDataLineage.propTypes = iconPropTypes;
}
const IbmCloudPakMulticloudMgmt = /*#__PURE__*/React.forwardRef(function IbmCloudPakMulticloudMgmt(_ref97, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref97;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M21,19a1.9822,1.9822,0,0,0-.5116.0743L18.707,17.293l-.0257.0257a2.8876,2.8876,0,0,0,0-2.6374l.0257.0257,1.7814-1.7813a2.0345,2.0345,0,1,0-1.4141-1.4141L17.293,13.293l.0257.0257a2.8876,2.8876,0,0,0-2.6374,0l.0257-.0257-1.7813-1.7814a2.0345,2.0345,0,1,0-1.4141,1.4141L13.293,14.707l.0258-.0258a2.8872,2.8872,0,0,0,0,2.6376l-.0258-.0258-1.7814,1.7813a2.0345,2.0345,0,1,0,1.4141,1.4141L14.707,18.707l-.0258-.0258a2.8872,2.8872,0,0,0,2.6376,0l-.0258.0258,1.7813,1.7814A1.9956,1.9956,0,1,0,21,19Zm-5-2a1,1,0,1,1,1-1A1.0006,1.0006,0,0,1,16,17Z"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudPakMulticloudMgmt.propTypes = iconPropTypes;
}
const IbmCloudPakNetezza = /*#__PURE__*/React.forwardRef(function IbmCloudPakNetezza(_ref98, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref98;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M19 10L19 19.2 13.5 10 11 10 11 22 13 22 13 12.8 18.5 22 21 22 21 10z"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30C8.3,30,2,23.7,2,16S8.3,2,16,2s14,6.3,14,14S23.7,30,16,30z M16,4C9.4,4,4,9.4,4,16s5.4,12,12,12s12-5.4,12-12 S22.6,4,16,4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudPakNetezza.propTypes = iconPropTypes;
}
const IbmCloudPakNetworkAutomation = /*#__PURE__*/React.forwardRef(function IbmCloudPakNetworkAutomation(_ref99, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref99;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3638,21.364,20.95,19.95a6.9993,6.9993,0,0,0,0-9.899L22.3638,8.636a9,9,0,0,1,0,12.728Z"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5356 18.5354l-1.414-1.4141a3.0039 3.0039 0 000-4.2426l1.414-1.4141A5.0048 5.0048 0 0119.5356 18.5354zM17 26H15V15a1 1 0 011-1h0a1 1 0 011 1zM12.4644 18.5354a5.0048 5.0048 0 010-7.0708l1.414 1.4141a3.0039 3.0039 0 000 4.2426z"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6362,21.364a9,9,0,0,1,0-12.728L11.05,10.0505a6.9993,6.9993,0,0,0,0,9.899Z"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudPakNetworkAutomation.propTypes = iconPropTypes;
}
const IbmCloudPakSecurity = /*#__PURE__*/React.forwardRef(function IbmCloudPakSecurity(_ref100, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref100;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M16,23.7285a6.0069,6.0069,0,0,1-6-6v-6.457l6-3,6,3v6.457A6.0069,6.0069,0,0,1,16,23.7285ZM12,12.5073v5.2212a4,4,0,0,0,8,0V12.5073l-4-2Z"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudPakSecurity.propTypes = iconPropTypes;
}
const IbmCloudPakSystem = /*#__PURE__*/React.forwardRef(function IbmCloudPakSystem(_ref101, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref101;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M15 11.671H17V15.328H15z",
    transform: "rotate(-45 16 13.5)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M15 16.672H17V20.329H15z",
    transform: "rotate(-45 16 18.5)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M19,24H13a2.0023,2.0023,0,0,1-2-2V10a2.0023,2.0023,0,0,1,2-2h6a2.0023,2.0023,0,0,1,2,2V22A2.0023,2.0023,0,0,1,19,24ZM13,10V22h6.0012L19,10Z"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudPakSystem.propTypes = iconPropTypes;
}
const IbmCloudPakWatsonAiops = /*#__PURE__*/React.forwardRef(function IbmCloudPakWatsonAiops(_ref102, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref102;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M14,24a1,1,0,0,1-.9614-.7253L11.2456,17H8V15h4a1,1,0,0,1,.9614.7253L14,19.36,17.0386,8.7253a1,1,0,0,1,1.9228,0L20.7544,15H24v2H20a1,1,0,0,1-.9614-.7253L18,12.64,14.9614,23.2747A1,1,0,0,1,14,24Z"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudPakWatsonAiops.propTypes = iconPropTypes;
}
const IbmSecurity = /*#__PURE__*/React.forwardRef(function IbmSecurity(_ref103, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref103;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M16,.0005,4,5.9784V20.0443a12,12,0,0,0,24,0V5.9784Zm6.83,27.3138L16,23.9119V26.14l5.0361,2.5088A10.0025,10.0025,0,0,1,6,20.0443V7.21L16,2.2284,26,7.21v3.75L16,5.9783V8.2062l10,4.9816v3.75L16,11.9562v2.2279l10,4.9815v.8787a9.9045,9.9045,0,0,1-.37,2.6871L16,17.934v2.2279l8.8952,4.4313A10.0252,10.0252,0,0,1,22.83,27.3143Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmSecurity.propTypes = iconPropTypes;
}
const IbmSecurityServices = /*#__PURE__*/React.forwardRef(function IbmSecurityServices(_ref104, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref104;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M26,20a2.97,2.97,0,0,0-1.8551.6607L22,19.4224V17.8157a3,3,0,1,0-2,0v1.6067l-2.1449,1.2383A2.97,2.97,0,0,0,16,20a3.02,3.02,0,1,0,2.9254,2.3525L21,21.1548l2.0746,1.1977A2.9978,2.9978,0,1,0,26,20ZM16,24a1,1,0,1,1,1-1A1.0006,1.0006,0,0,1,16,24Zm5-10a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,21,14Zm5,10a1,1,0,1,1,1-1A1.0006,1.0006,0,0,1,26,24Z"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M16,31A11.0125,11.0125,0,0,1,5,20V6.3823L15.9873.8816,26.4478,6.1187l-.8956,1.7885L15.9873,3.1184,7,7.6177V20a9.0008,9.0008,0,0,0,14.3994,7.2012L22.6006,28.8A10.9077,10.9077,0,0,1,16,31Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmSecurityServices.propTypes = iconPropTypes;
}
const IbmWatsonAssistant = /*#__PURE__*/React.forwardRef(function IbmWatsonAssistant(_ref105, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref105;
  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation["IbmWatsonAssistant"]) {
      didWarnAboutDeprecation["IbmWatsonAssistant"] = true;
      console.warn("Icon renamed and replaced by ibm-watsonx--assistant to correspond with the new watsonx platform and product suite. As a result, the IbmWatsonAssistant component will be removed in the next major version of @carbon/icons-react.");
    }
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M28 2H18c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h2.4l1.7 3 1.7-1-2.3-4H18V4h10v6h-3v2h3c1.1 0 2-.9 2-2V4C30 2.9 29.1 2 28 2zM14.7 31L13 30l3.5-6H22c1.1 0 2-.9 2-2v-5h2v5c0 2.2-1.8 4-4 4h-4.4L14.7 31z"
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "17",
    r: "1"
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    cx: "14",
    cy: "17",
    r: "1"
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    cx: "18",
    cy: "17",
    r: "1"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M12,26H6c-2.2,0-4-1.8-4-4V12c0-2.2,1.8-4,4-4h8v2H6c-1.1,0-2,0.9-2,2v10c0,1.1,0.9,2,2,2h6V26z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmWatsonAssistant.propTypes = iconPropTypes;
}
const IbmWatsonDiscovery = /*#__PURE__*/React.forwardRef(function IbmWatsonDiscovery(_ref106, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref106;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M6 17H14V19H6z"
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    cx: "3",
    cy: "18",
    r: "1"
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    cx: "13",
    cy: "14",
    r: "1"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M2 13H10V15H2zM6 9H14V11H6z"
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    cx: "3",
    cy: "10",
    r: "1"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M30,28.6l-7.4-7.4c1.5-2,2.4-4.5,2.4-7.2c0-6.6-5.4-12-12-12C9.7,2,6.6,3.3,4.3,5.8l1.5,1.4C7.6,5.1,10.2,4,13,4 c5.5,0,10,4.5,10,10s-4.5,10-10,10c-3,0-5.8-1.3-7.7-3.6l-1.5,1.3C6,24.4,9.4,26,13,26c3.2,0,6.1-1.3,8.3-3.3l7.3,7.3L30,28.6z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmWatsonDiscovery.propTypes = iconPropTypes;
}
const IbmWatsonKnowledgeCatalog = /*#__PURE__*/React.forwardRef(function IbmWatsonKnowledgeCatalog(_ref107, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref107;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M23 27.2L20.4 24.6 19 26 23 30 30 23 28.6 21.6zM12 18H20V20H12zM12 13H20V15H12zM12 8H20V10H12z"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M16,28H6v-4h2v-2H6v-5h2v-2H6v-5h2V8H6V4h18v16h2V4c0-1.1-0.9-2-2-2H6C4.9,2,4,2.9,4,4v4H2v2h2v5H2v2h2v5H2v2h2v4 c0,1.1,0.9,2,2,2h10V28z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmWatsonKnowledgeCatalog.propTypes = iconPropTypes;
}
const IbmWatsonKnowledgeStudio = /*#__PURE__*/React.forwardRef(function IbmWatsonKnowledgeStudio(_ref108, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref108;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M20 25H27V27H20zM22 29H25V31H22zM27 23h-2c0-1.1.4-2 1.2-2.8l.5-.5c.8-.8 1.3-2 1.3-3.2 0-2.5-2-4.5-4.5-4.5S19 14 19 16.5c0 1.2.5 2.3 1.3 3.2l.5.5C21.6 21 22 21.9 22 23h-2c0-.5-.2-1-.6-1.4l-.5-.5c-1.2-1.2-1.9-2.9-1.9-4.6 0-3.6 2.9-6.5 6.5-6.5s6.5 2.9 6.5 6.5c0 1.7-.7 3.4-1.9 4.6l-.5.5C27.2 22 27 22.5 27 23zM6 22H14V24H6z"
  })), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "19",
    r: "1"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M6 18H9V20H6zM6 14H13V16H6zM10 10H17V12H10z"
  })), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "11",
    r: "1"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M16 6H20V8H16z"
  })), _circle57 || (_circle57 = /*#__PURE__*/React.createElement("circle", {
    cx: "13",
    cy: "7",
    r: "1"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6H10V8H6z"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M18,28H4V4l18,0v4h2V4c0-1.1-0.9-2-2-2H4C2.9,2,2,2.9,2,4v24c0,1.1,0.9,2,2,2h14V28z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmWatsonKnowledgeStudio.propTypes = iconPropTypes;
}
const IbmWatsonLanguageTranslator = /*#__PURE__*/React.forwardRef(function IbmWatsonLanguageTranslator(_ref109, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref109;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M16 28h-3c-3.9 0-7-3.1-7-7v-4h2v4c0 2.8 2.2 5 5 5h3V28zM28 30h2.2l-4.6-11h-2.2l-4.6 11H21l.8-2h5.3L28 30zM22.7 26l1.8-4.4 1.8 4.4H22.7zM28 15h-2v-4c0-2.8-2.2-5-5-5h-4V4h4c3.9 0 7 3.1 7 7V15zM14 5V3H9V1H7v2H2v2h8.2C10 5.9 9.4 7.5 8 9 7.4 8.3 6.9 7.6 6.6 7H4.3c.4 1 1.1 2.2 2.1 3.3C5.6 11 4.4 11.6 3 12.1L3.7 14c1.8-.7 3.2-1.5 4.3-2.3 1.1.9 2.5 1.7 4.3 2.3l.7-1.9c-1.4-.5-2.6-1.2-3.5-1.8 1.9-2 2.5-4.1 2.7-5.3H14z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmWatsonLanguageTranslator.propTypes = iconPropTypes;
}
const IbmWatsonMachineLearning = /*#__PURE__*/React.forwardRef(function IbmWatsonMachineLearning(_ref110, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref110;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M3.6 22.5c-1-2-1.6-4.2-1.6-6.5C2 8.3 8.3 2 16 2v2C9.4 4 4 9.4 4 16c0 2 .5 3.8 1.4 5.5L3.6 22.5zM28 16c0 6.6-5.4 12-12 12-2.9 0-5.6-1-7.7-2.8l5.7-5.7L12.6 18l-6.5 6.5c-.4.4-.4 1 0 1.4C8.7 28.5 12.3 30 16 30c7.7 0 14-6.3 14-14H28z"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M18,25c-0.1,0-0.3,0-0.4-0.1c-0.3-0.1-0.6-0.4-0.6-0.8l-0.7-5l2-0.3l0.4,3.3l2.2-1.7V15c0-0.3,0.1-0.5,0.3-0.7l3.2-3.2 c0.9-0.9,1.5-2.2,1.5-3.5V6l-1.5,0c-1.3,0-2.6,0.5-3.5,1.5l-3.2,3.2C17.5,10.9,17.3,11,17,11h-5.5l-1.7,2.2l3.3,0.4l-0.3,2l-5-0.7 c-0.4,0-0.7-0.3-0.8-0.6s-0.1-0.7,0.1-1l3-4C10.4,9.1,10.7,9,11,9h5.6l3-3c1.3-1.3,3.1-2,4.9-2H26c1.1,0,2,0.9,2,2v1.5 c0,1.9-0.7,3.6-2,4.9l-3,3V21c0,0.3-0.1,0.6-0.4,0.8l-4,3C18.4,24.9,18.2,25,18,25z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmWatsonMachineLearning.propTypes = iconPropTypes;
}
const IbmWatsonNaturalLanguageClassifier = /*#__PURE__*/React.forwardRef(function IbmWatsonNaturalLanguageClassifier(_ref111, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref111;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M28 12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2h-4c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h1v4h-3v2h8v-2h-3v-4H28zM24 4h4v6h-4V4zM21 22.4L19.6 21 16 24.6 12.4 21 11 22.4 14.6 26 11 29.6 12.4 31 16 27.4 19.6 31 21 29.6 17.4 26zM12 18L15 18 15 21 17 21 17 18 20 18 20 16 12 16zM10 12V4c0-1.1-.9-2-2-2H3v2h5v2H4C2.9 6 2 6.9 2 8v2c0 1.1.9 2 2 2h1v4H2v2h8v-2H7v-4H10zM4 8h4v2H4V8z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmWatsonNaturalLanguageClassifier.propTypes = iconPropTypes;
}
const IbmWatsonNaturalLanguageUnderstanding = /*#__PURE__*/React.forwardRef(function IbmWatsonNaturalLanguageUnderstanding(_ref112, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref112;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M6 23H11V25H6zM6 19H11V21H6z"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M13 30H4c-1.1 0-2-.9-2-2V17c0-1.1.9-2 2-2h9c1.1 0 2 .9 2 2v11C15 29.1 14.1 30 13 30zM4 17v11h9V17H4zM19 2H27V4H19zM22 6H30V8H22zM22 10H30V12H22zM19 14H27V16H19zM22 18H30V20H22zM12 1l-1.4 1.4L13.2 5H4C2.9 5 2 5.9 2 7v5h2V7h9.2l-2.6 2.6L12 11l5-5L12 1z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmWatsonNaturalLanguageUnderstanding.propTypes = iconPropTypes;
}
const IbmWatsonOpenscale = /*#__PURE__*/React.forwardRef(function IbmWatsonOpenscale(_ref113, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref113;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M4 28c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3S5.7 28 4 28zM4 24c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1S4.6 24 4 24zM28 28c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3S29.7 28 28 28zM28 24c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1S28.6 24 28 24zM22.4 4.4l-.9 1.8C26.1 8.4 29 13 29 18c0 .7-.1 1.4-.2 2.1l2 .3c.1-.8.2-1.6.2-2.5C31 12.2 27.6 6.9 22.4 4.4zM16 7c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3S17.7 7 16 7zM16 3c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1S16.6 3 16 3z"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5,13.6l-1-1.7L17,16.3V9h-2v7.2L6.2,11c-0.5-0.3-1.1-0.1-1.4,0.3s-0.1,1.1,0.3,1.4L14,18l-6.2,3.6l1,1.7l6.2-3.6V30 c0,0.6,0.4,1,1,1s1-0.4,1-1V19.8l6.2,3.7l1-1.7L18,18L25.5,13.6z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmWatsonOpenscale.propTypes = iconPropTypes;
}
const IbmWatsonOrders = /*#__PURE__*/React.forwardRef(function IbmWatsonOrders(_ref114, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref114;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M28 13h-2v-2c0-2.8-2.2-5-5-5h-3V4h3c3.9 0 7 3.1 7 7V13zM22 20H25V22H22zM22 24H25V26H22z"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M27 30h-5v-2h5V18h-7v9c0 1.7-1.3 3-3 3s-3-1.3-3-3v-3h2v3c0 .6.4 1 1 1s1-.4 1-1V16h11v12C29 29.1 28.1 30 27 30zM12 28h-1c-3.9 0-7-3.1-7-7v-4h2v4c0 2.8 2.2 5 5 5h1V28zM11 10v2h3c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2H4C2.9 2 2 2.9 2 4v6c0 1.1.9 2 2 2h2.4l1.7 3 1.7-1-2.3-4H4V4h10v6H11z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmWatsonOrders.propTypes = iconPropTypes;
}
const IbmWatsonQuery = /*#__PURE__*/React.forwardRef(function IbmWatsonQuery(_ref115, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref115;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M22,24c-0.2,0-0.3,0-0.5,0L18.2,18c0.5-0.5,0.8-1.2,0.8-2c0-1.7-1.3-3-3-3s-3,1.3-3,3c0,0.8,0.3,1.5,0.8,2L10.5,24 c-0.2,0-0.3,0-0.5,0c-1.7,0-3,1.3-3,3s1.3,3,3,3s3-1.3,3-3c0-0.8-0.3-1.5-0.8-2l3.3-6.1c0.2,0,0.3,0,0.5,0s0.3,0,0.5,0l3.3,6.1 c-0.5,0.5-0.8,1.2-0.8,2c0,1.7,1.3,3,3,3s3-1.3,3-3S23.7,24,22,24z M16,15c0.6,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1S15.4,15,16,15z M10,28c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S10.6,28,10,28z M22,28c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S22.6,28,22,28z"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8,9.1C23.9,5,20.3,2,16,2S8.1,5,7.2,9.1C4.2,9.7,2,12.4,2,15.5C2,19.1,4.9,22,8.5,22H9v-2H8.5C6,20,4,18,4,15.5 c0-2.3,1.8-4.3,4.1-4.5L9,11l0.1-0.8C9.5,6.6,12.5,4,16,4c3.5,0,6.5,2.6,6.9,6.1L23,11l0.8,0.1c2.3,0.2,4.1,2.2,4.1,4.5 c0,2.5-2,4.5-4.5,4.5H23v2h0.5c3.6,0,6.5-2.9,6.5-6.5C30,12.4,27.8,9.7,24.8,9.1z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmWatsonQuery.propTypes = iconPropTypes;
}
const IbmWatsonSpeechToText = /*#__PURE__*/React.forwardRef(function IbmWatsonSpeechToText(_ref116, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref116;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M14 18H4c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h2.4l1.7 3 1.7-1-2.3-4H4v-6h10v6h-3v2h3c1.1 0 2-.9 2-2v-6C16 18.9 15.1 18 14 18zM19 26h2c3.9 0 7-3.1 7-7v-2h-2v2c0 2.8-2.2 5-5 5h-2V26zM18 11H24V13H18zM18 7H30V9H18zM18 3H30V5H18zM4 14h2v-2c0-2.8 2.2-5 5-5h4V5h-4c-3.9 0-7 3.1-7 7V14z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmWatsonSpeechToText.propTypes = iconPropTypes;
}
const IbmWatsonStudio = /*#__PURE__*/React.forwardRef(function IbmWatsonStudio(_ref117, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref117;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M25 21c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5S27.8 21 25 21zM25 13c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3S26.7 13 25 13zM14 11V6c0-1.1-.9-2-2-2h-2v2h2v5c0 2.1 1.1 3.9 2.7 5-1.6 1.1-2.7 2.9-2.7 5v5h-2v2h2c1.1 0 2-.9 2-2v-5c0-2.2 1.8-4 4-4v-2C15.8 15 14 13.2 14 11zM2 30v-6h6v6H2zM4 26v2h2v-2H4zM2 19v-6h6v6H2zM4 15v2h2v-2H4zM2 8V2h6v6H2zM4 4v2h2V4H4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmWatsonStudio.propTypes = iconPropTypes;
}
const IbmWatsonTextToSpeech = /*#__PURE__*/React.forwardRef(function IbmWatsonTextToSpeech(_ref118, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref118;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M13 26h-2c-3.9 0-7-3.1-7-7v-2h2v2c0 2.8 2.2 5 5 5h2V26zM18 18h10c1.1 0 2 .9 2 2v6c0 1.1-.9 2-2 2h-2.4l-1.7 3-1.7-1 2.3-4H28v-6H18v6h3v2h-3c-1.1 0-2-.9-2-2v-6C16 18.9 16.9 18 18 18zM28 14h-2v-2c0-2.8-2.2-5-5-5h-4V5h4c3.9 0 7 3.1 7 7V14zM2 11H8V13H2zM2 7H14V9H2zM2 3H14V5H2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmWatsonTextToSpeech.propTypes = iconPropTypes;
}
const IbmWatsonToneAnalyzer = /*#__PURE__*/React.forwardRef(function IbmWatsonToneAnalyzer(_ref119, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref119;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9,10c-0.6-0.6-1.5-1-2.4-1s-1.8,0.4-2.4,1l-1.4-1.4c1-1,2.4-1.6,3.8-1.6s2.9,0.6,3.8,1.6L23.9,10z"
  })), _circle58 || (_circle58 = /*#__PURE__*/React.createElement("circle", {
    cx: "24",
    cy: "5",
    r: "1"
  })), _circle59 || (_circle59 = /*#__PURE__*/React.createElement("circle", {
    cx: "19",
    cy: "5",
    r: "1"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M15 0l13 0c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2h-3.5l-1.7 3L21 16l2.3-4H28V2H15v10h5v2h-5c-1.1 0-2-.9-2-2V2C13 .9 13.9 0 15 0zM20 19v6c0 .6-.4 1-1 1h-5v2h5c1.7 0 3-1.3 3-3v-6H20zM15.4 20.4c-.8 1-2.1 1.6-3.4 1.6s-2.6-.6-3.4-1.6L7 21.6c1.2 1.4 3 2.4 5 2.4s3.8-.9 5-2.4L15.4 20.4z"
  })), _circle60 || (_circle60 = /*#__PURE__*/React.createElement("circle", {
    cx: "15.5",
    cy: "17.5",
    r: "1.5"
  })), _circle61 || (_circle61 = /*#__PURE__*/React.createElement("circle", {
    cx: "8.5",
    cy: "17.5",
    r: "1.5"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1,26H5c-0.6,0-1-0.4-1-1V14c0-0.6,0.4-1,1-1h5v-2H5c-1.7,0-3,1.3-3,3v11c0,1.7,1.3,3,3,3h4l2.3,4l1.7-1L10.1,26z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmWatsonToneAnalyzer.propTypes = iconPropTypes;
}
const IbmWatsonxAssistant = /*#__PURE__*/React.forwardRef(function IbmWatsonxAssistant(_ref120, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref120;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M28 2h-10c-1.1035 0-2 .8965-2 2v6c0 1.1035.8965 2 2 2h2.4229s1.7314 3 1.7314 3l1.7324-1-2.3096-4h-3.5771V4h10v6h-3s0 2 0 2h3c1.1035 0 2-.8965 2-2V4c0-1.1035-.8965-2-2-2zM14.6904 31l-1.7324-1 3.4648-6h5.5771c1.1046 0 2-.8954 2-2v-5h2v5c0 2.2091-1.7909 4-4 4h-4.4229l-2.8867 5z"
  })), _circle62 || (_circle62 = /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "17",
    r: "1"
  })), _circle63 || (_circle63 = /*#__PURE__*/React.createElement("circle", {
    cx: "14",
    cy: "17",
    r: "1"
  })), _circle64 || (_circle64 = /*#__PURE__*/React.createElement("circle", {
    cx: "18",
    cy: "17",
    r: "1"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "m12,26h-6c-2.2091,0-4-1.7909-4-4v-10c0-2.2091,1.7909-4,4-4h8v2H6c-1.1046,0-2,.8954-2,2v10c0,1.1046.8954,2,2,2h6v2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmWatsonxAssistant.propTypes = iconPropTypes;
}
const IbmWatsonxCodeAssistant = /*#__PURE__*/React.forwardRef(function IbmWatsonxCodeAssistant(_ref121, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref121;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M11 28h-2c-3.8599 0-7-3.1401-7-7v-2h2v2c0 2.7568 2.2432 5 5 5h2v2zM28.17 26L25.59 28.58 27 30 31 26 27 22 25.58 23.41 28.17 26zM22 31L20.085 30.4229 23 21 24.9149 21.5771 22 31zM16.83 26L19.41 23.42 18 22 14 26 18 30 19.42 28.59 16.83 26zM30 19h-2v-7c0-2.7614-2.2386-5-5-5h-4v-2h4c3.866 0 7 3.134 7 7v7z"
  })), _circle65 || (_circle65 = /*#__PURE__*/React.createElement("circle", {
    cx: "3",
    cy: "4",
    r: "1"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M6 3H16V5H6z"
  })), _circle66 || (_circle66 = /*#__PURE__*/React.createElement("circle", {
    cx: "3",
    cy: "12",
    r: "1"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M6 11H16V13H6zM2 15H12V17H2z"
  })), _circle67 || (_circle67 = /*#__PURE__*/React.createElement("circle", {
    cx: "15",
    cy: "8",
    r: "1"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M2 7H12V9H2z"
  })), _circle68 || (_circle68 = /*#__PURE__*/React.createElement("circle", {
    cx: "15",
    cy: "16",
    r: "1"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmWatsonxCodeAssistant.propTypes = iconPropTypes;
}
const IbmWatsonxCodeAssistantForZ = /*#__PURE__*/React.forwardRef(function IbmWatsonxCodeAssistantForZ(_ref122, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref122;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M29.17 25L26.59 27.58 28 29 32 25 28 21 26.58 22.41 29.17 25zM23 30L21.0851 29.4229 24 20 25.9149 20.5771 23 30zM17.83 25L20.41 22.42 19 21 15 25 19 29 20.42 27.59 17.83 25zM18 19h-2V5c0-1.1028.8972-2 2-2h9c1.1028 0 2 .8972 2 2v11h-2V5h-9v14zM12 3H3c-1.1028 0-2 .8975-2 2v22c0 1.1025.8972 2 2 2h9c1.1028 0 2-.8975 2-2V5c0-1.1025-.8972-2-2-2zm.0002 7.0366l-6.925-5.0366h6.9248l.0002 5.0366zm-.7004 1.9634l-8.2998 6.0361V5.9639l8.2998 6.0361zm.7007 1.9634l.0007 11.8169-8.2795-5.7959 8.2788-6.021zm-9.0005 7.9575l7.2563 5.0791H3v-5.0791zm9 5.0791l.0012-.002v.002h-.0012z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmWatsonxCodeAssistantForZ.propTypes = iconPropTypes;
}
const IbmWatsonxOrchestrate = /*#__PURE__*/React.forwardRef(function IbmWatsonxOrchestrate(_ref123, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref123;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "m27.9248,19.4282c-1.123,1.6104-2.9641,2.5718-4.9248,2.5718-2.1233,0-4.0464-1.0874-5.1438-2.9092l-1.7129,1.0322c1.4624,2.4277,4.0256,3.877,6.8567,3.877,1.4231,0,2.7925-.3911,3.9922-1.0835-2.3442,3.6958-6.4814,6.0835-10.9922,6.0835-5.7104,0-10.8347-3.8184-12.4617-9.2852l-1.917.5703c1.8774,6.3086,7.79,10.7148,14.3787,10.7148s12.5012-4.4062,14.3787-10.7148l-2.4539-.8569Z"
  })), _circle69 || (_circle69 = /*#__PURE__*/React.createElement("circle", {
    cx: "30",
    cy: "16",
    r: "2"
  })), _circle70 || (_circle70 = /*#__PURE__*/React.createElement("circle", {
    cx: "2",
    cy: "16",
    r: "2"
  })), _circle71 || (_circle71 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "m16,1C9.4114,1,3.4988,5.4062,1.6213,11.7148l2.4539.8569c1.123-1.6104,2.9641-2.5718,4.9248-2.5718s3.8018.9614,4.9248,2.5718l1.6406-1.144c-1.4971-2.1465-3.9514-3.4277-6.5654-3.4277-1.4231,0-2.7925.3911-3.9922,1.0835,2.3442-3.6953,6.4814-6.0835,10.9922-6.0835,5.7104,0,10.8347,3.8184,12.4617,9.2852l1.917-.5703c-1.8774-6.3086-7.79-10.7148-14.3787-10.7148Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmWatsonxOrchestrate.propTypes = iconPropTypes;
}
const IbmZCloudModStack = /*#__PURE__*/React.forwardRef(function IbmZCloudModStack(_ref124, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref124;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M18.496,27.386L16,28.842L5,22.426v-5.852l10.016-5.843C15.308,10.897,15.641,11,16,11c1.104,0,2-0.896,2-2s-0.896-2-2-2 s-2,0.896-2,2c0,0.003,0.001,0.005,0.001,0.008L3.496,15.136C3.189,15.315,3,15.645,3,16v7c0,0.355,0.189,0.685,0.496,0.864l12,7 C15.652,30.955,15.826,31,16,31s0.348-0.045,0.504-0.136l3-1.75L18.496,27.386z"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M28.504,8.136l-3-1.75l-1.008,1.728L27,9.574v12.852l-4.593,2.679l-10.409-6.093C11.999,19.007,12,19.004,12,19 c0-1.104-0.896-2-2-2s-2,0.896-2,2s0.896,2,2,2c0.358,0,0.69-0.102,0.981-0.267l10.92,6.393c0.156,0.091,0.331,0.137,0.505,0.137 c0.174,0,0.348-0.045,0.504-0.136l5.594-3.263C28.811,23.685,29,23.355,29,23V9C29,8.645,28.811,8.315,28.504,8.136z"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M23,17.277V5.5c0-0.355-0.189-0.685-0.496-0.864l-6-3.5C16.348,1.045,16.174,1,16,1s-0.348,0.045-0.504,0.136l-12,7 C3.189,8.315,3,8.645,3,9v2.999h2V9.574l11-6.417l5,2.917v11.203c-0.595,0.347-1,0.984-1,1.723c0,1.104,0.896,2,2,2s2-0.896,2-2 C24,18.262,23.595,17.624,23,17.277z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmZCloudModStack.propTypes = iconPropTypes;
}
const IbmZEnvironmentsDevSecOps = /*#__PURE__*/React.forwardRef(function IbmZEnvironmentsDevSecOps(_ref125, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref125;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "m23.5,16v2c3.0327,0,5.5,2.4673,5.5,5.5s-2.4673,5.5-5.5,5.5-5.5-2.4673-5.5-5.5h-2c0,4.1422,3.3578,7.5,7.5,7.5s7.5-3.3578,7.5-7.5-3.3578-7.5-7.5-7.5Z"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 26c1.3807 0 2.5-1.1193 2.5-2.5s-1.1193-2.5-2.5-2.5c-.3217 0-.6268.066-.9093.1766l-4.8837-4.8837-1.4141 1.4141 4.8837 4.8837c-.1107.2825-.1766.5876-.1766.9093 0 1.3807 1.1193 2.5 2.5 2.5zM29 13h-2v-3.4257l-11-6.4166-3 1.7499v8.0924h-2V4.3333c0-.3557.189-.6846.4961-.8638l4-2.3333c.1558-.0908.3298-.1362.5039-.1362s.3481.0454.5039.1362l12 7c.3071.1792.4961.5081.4961.8638v4zM7 6H9V16H7z"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "m13.9998,29.991l-10.5037-6.1272c-.3071-.1792-.4961-.5081-.4961-.8638v-14h2v13.4257l10.0076,5.8378-1.0078,1.7275Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmZEnvironmentsDevSecOps.propTypes = iconPropTypes;
}

export { Home, HorizontalView, Hospital, HospitalBed, Hotel, Hourglass, Html, HtmlReference, Http, Humidity, HumidityAlt, Hurricane, HybridNetworking, HybridNetworkingAlt, IbmAiOnZ, IbmAiopsInsights, IbmBluepay, IbmCloud, IbmCloudAppId, IbmCloudBareMetalServer, IbmCloudBareMetalServersVpc, IbmCloudCitrixDaas, IbmCloudContinuousDelivery, IbmCloudDedicatedHost, IbmCloudDirectLink_1Connect, IbmCloudDirectLink_1Dedicated, IbmCloudDirectLink_1DedicatedHosting, IbmCloudDirectLink_1Exchange, IbmCloudDirectLink_2Connect, IbmCloudDirectLink_2Dedicated, IbmCloudDirectLink_2DedicatedHosting, IbmCloudEventNotification, IbmCloudEventStreams, IbmCloudForEducation, IbmCloudHpc, IbmCloudHsm, IbmCloudHyperProtectCryptoServices, IbmCloudHyperProtectDbaas, IbmCloudHyperProtectVs, IbmCloudInternetServices, IbmCloudIpsecVpn, IbmCloudKeyProtect, IbmCloudKubernetesService, IbmCloudLogging, IbmCloudMassDataMigration, IbmCloudPakApplications, IbmCloudPakBusinessAutomation, IbmCloudPakData, IbmCloudPakIntegration, IbmCloudPakMantaAutomatedDataLineage, IbmCloudPakMulticloudMgmt, IbmCloudPakNetezza, IbmCloudPakNetworkAutomation, IbmCloudPakSecurity, IbmCloudPakSystem, IbmCloudPakWatsonAiops, IbmCloudPal, IbmCloudPrivilegedAccessGateway, IbmCloudProjects, IbmCloudResiliency, IbmCloudSecretsManager, IbmCloudSecurityComplianceCenter, IbmCloudSecurityComplianceCenterWorkloadProtection, IbmCloudSubnets, IbmCloudSysdigSecure, IbmCloudTransitGateway, IbmCloudVirtualServerClassic, IbmCloudVirtualServerVpc, IbmCloudVpc, IbmCloudVpcEndpoints, IbmCloudant, IbmContentServices, IbmDataReplication, IbmDatastage, IbmDb2, IbmDb2Alt, IbmDb2Warehouse, IbmEventAutomation, IbmEventEndpointMgmt, IbmEventProcessing, IbmEventStreams, IbmMatch_360, IbmMq, IbmOpenEnterpriseLanguages, IbmOpenshiftContainerPlatformOnVpcForRegulatedIndustries, IbmPowerVs, IbmPowerVsPrivateCloud, IbmPowerWithVpc, IbmPrivatePathServices, IbmProcessMining, IbmSaasConsole, IbmSapOnPower, IbmSecureInfrastructureOnVpcForRegulatedIndustries, IbmSecurity, IbmSecurityServices, IbmTelehealth, IbmTenet, IbmToolchain, IbmTurbonomic, IbmVpnForVpc, IbmVsiOnVpcForRegulatedIndustries, IbmWatsonAssistant, IbmWatsonDiscovery, IbmWatsonKnowledgeCatalog, IbmWatsonKnowledgeStudio, IbmWatsonLanguageTranslator, IbmWatsonMachineLearning, IbmWatsonNaturalLanguageClassifier, IbmWatsonNaturalLanguageUnderstanding, IbmWatsonOpenscale, IbmWatsonOrders, IbmWatsonQuery, IbmWatsonSpeechToText, IbmWatsonStudio, IbmWatsonTextToSpeech, IbmWatsonToneAnalyzer, IbmWatsonxAssistant, IbmWatsonxCodeAssistant, IbmWatsonxCodeAssistantForZ, IbmWatsonxOrchestrate, IbmWaziDeploy, IbmZCloudModStack, IbmZEnvironmentsDevSecOps, WatsonHealthHoleFilling, WatsonHealthHoleFillingCursor };
